<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 206.7 324.6"
    >
      <defs>
        <linearGradient
          id="gradient_137"
          data-name="linear gradient 137"
          x1="358.01"
          y1="-3917.74"
          x2="357.91"
          y2="-3927.57"
          gradientTransform="matrix(1, 0, 0, -1, -133.16, -3699.54)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#cddcdc" />
          <stop offset="1" stop-color="#fcfcfc" />
        </linearGradient>
        <radialGradient
          id="gradient_132"
          data-name="linear gradient 132"
          cx="341.47"
          cy="-3944.95"
          r="17.45"
          gradientTransform="matrix(0.94, 0, 0, -1, -102.25, -3699.54)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#cdd2d2" />
          <stop offset="1" stop-color="#fcfcfc" />
        </radialGradient>
        <linearGradient
          id="gradient_137-2"
          x1="359.45"
          y1="-3943.42"
          x2="361.26"
          y2="-3969.85"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3"
          data-name="linear gradient 3"
          cx="342.44"
          cy="-2690.52"
          r="15.53"
          gradientTransform="matrix(0.94, 0, 0, -0.76, -102.25, -1769.38)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-3"
          x1="365.79"
          y1="-3970.67"
          x2="366.5"
          y2="-3993.46"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-2"
          data-name="linear gradient 3"
          cx="353.19"
          cy="-2785.33"
          r="19.24"
          gradientTransform="matrix(0.94, 0, 0, -0.77, -102.25, -1832.31)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-4"
          x1="373.22"
          y1="-3998.73"
          x2="372.62"
          y2="-4018.49"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-3"
          data-name="linear gradient 3"
          cx="360.15"
          cy="-1316.81"
          r="15.37"
          gradientTransform="matrix(0.94, 0, 0, -0.59, -102.25, -466.14)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-5"
          x1="380.47"
          y1="-4015.22"
          x2="380.27"
          y2="-4032.79"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-4"
          data-name="linear gradient 3"
          cx="368.81"
          cy="-2009.88"
          r="11.93"
          gradientTransform="matrix(0.94, 0, 0, -0.66, -102.25, -993.49)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-6"
          x1="389.66"
          y1="-4031.08"
          x2="391.57"
          y2="-4049.46"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-5"
          data-name="linear gradient 3"
          cx="379.96"
          cy="-4051.55"
          r="12.02"
          gradientTransform="matrix(0.94, 0, 0, -1, -102.25, -3699.54)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-7"
          x1="404.26"
          y1="-4042.27"
          x2="404.36"
          y2="-4058.54"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-6"
          data-name="linear gradient 3"
          cx="394.91"
          cy="-3566.1"
          r="9.79"
          gradientTransform="matrix(0.94, 0, 0, -0.89, -102.25, -2804.96)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138"
          data-name="linear gradient 138"
          x1="426.7"
          y1="-4044.81"
          x2="422.29"
          y2="-4068.06"
          gradientTransform="matrix(1, 0, 0, -1, -133.16, -3699.54)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#cddcdc" />
          <stop offset="0.18" stop-color="#e1eaea" />
          <stop offset="0.39" stop-color="#f0f4f4" />
          <stop offset="0.64" stop-color="#f9fafa" />
          <stop offset="1" stop-color="#fcfcfc" />
        </linearGradient>
        <radialGradient
          id="gradient_136"
          data-name="linear gradient 136"
          cx="415.32"
          cy="-4068.83"
          r="13.08"
          gradientTransform="matrix(0.94, 0, 0, -1, -102.25, -3699.54)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-8"
          x1="-2874.96"
          y1="-3917.74"
          x2="-2875.06"
          y2="-3927.57"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_132-2"
          cx="-2879.2"
          cy="-3944.95"
          r="17.45"
          gradientTransform="translate(-2331.2 -3699.5) rotate(180) scale(0.94 1)"
          xlink:href="#gradient_132"
        />
        <linearGradient
          id="gradient_137-9"
          x1="-2873.52"
          y1="-3943.42"
          x2="-2871.71"
          y2="-3969.85"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-7"
          data-name="linear gradient 3"
          cx="-2878.22"
          cy="-2690.52"
          r="15.53"
          gradientTransform="translate(-2331.2 -1769.4) rotate(180) scale(0.94 0.76)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-10"
          x1="-2867.17"
          y1="-3970.67"
          x2="-2866.47"
          y2="-3993.46"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-8"
          data-name="linear gradient 3"
          cx="-2867.47"
          cy="-2785.33"
          r="19.24"
          gradientTransform="translate(-2331.2 -1832.3) rotate(180) scale(0.94 0.77)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-11"
          x1="-2859.74"
          y1="-3998.73"
          x2="-2860.35"
          y2="-4018.49"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-9"
          data-name="linear gradient 3"
          cx="-2860.52"
          cy="-1316.81"
          r="15.37"
          gradientTransform="translate(-2331.2 -466.1) rotate(180) scale(0.94 0.59)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-12"
          x1="-2852.5"
          y1="-4015.22"
          x2="-2852.7"
          y2="-4032.79"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-10"
          data-name="linear gradient 3"
          cx="-2851.85"
          cy="-2009.88"
          r="11.93"
          gradientTransform="translate(-2331.2 -993.5) rotate(180) scale(0.94 0.66)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-13"
          x1="-2843.3"
          y1="-4031.08"
          x2="-2841.39"
          y2="-4049.46"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-11"
          data-name="linear gradient 3"
          cx="-2840.7"
          cy="-4051.55"
          r="12.02"
          gradientTransform="translate(-2331.2 -3699.5) rotate(180) scale(0.94 1)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-14"
          x1="-2828.7"
          y1="-4042.27"
          x2="-2828.6"
          y2="-4058.54"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-12"
          data-name="linear gradient 3"
          cx="-2825.76"
          cy="-3566.1"
          r="9.79"
          gradientTransform="translate(-2331.2 -2805) rotate(180) scale(0.94 0.89)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138-2"
          x1="-2806.26"
          y1="-4044.81"
          x2="-2810.67"
          y2="-4068.06"
          gradientTransform="translate(-2499.1 -3699.5) rotate(180)"
          xlink:href="#gradient_138"
        />
        <radialGradient
          id="gradient_136-2"
          data-name="linear gradient 136"
          cx="-2805.34"
          cy="-4068.83"
          r="13.08"
          gradientTransform="translate(-2331.2 -3699.5) rotate(180) scale(0.94 1)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-15"
          x1="220.37"
          y1="209.55"
          x2="220.27"
          y2="199.71"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_132-3"
          cx="214.63"
          cy="182.34"
          r="17.45"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_132"
        />
        <linearGradient
          id="gradient_137-16"
          x1="221.97"
          y1="183.86"
          x2="223.78"
          y2="157.46"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-13"
          data-name="linear gradient 3"
          cx="215.6"
          cy="2756.61"
          r="15.53"
          gradientTransform="translate(0 -1930.2) scale(1 0.76)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-17"
          x1="228.66"
          y1="156.62"
          x2="229.36"
          y2="133.83"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-14"
          data-name="linear gradient 3"
          cx="226.35"
          cy="2605.59"
          r="19.24"
          gradientTransform="translate(0 -1867.2) scale(1 0.77)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-18"
          x1="236.51"
          y1="128.56"
          x2="235.91"
          y2="108.79"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-15"
          data-name="linear gradient 3"
          cx="233.3"
          cy="5630.31"
          r="15.37"
          gradientTransform="translate(0 -3233.4) scale(1 0.59)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-19"
          x1="244.21"
          y1="112.07"
          x2="244.01"
          y2="94.5"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-16"
          data-name="linear gradient 3"
          cx="241.97"
          cy="4240.75"
          r="11.93"
          gradientTransform="translate(0 -2706.1) scale(1 0.66)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-20"
          x1="254.03"
          y1="96.18"
          x2="255.94"
          y2="77.81"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-17"
          data-name="linear gradient 3"
          cx="253.12"
          cy="75.74"
          r="12.02"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-21"
          x1="269.48"
          y1="85.01"
          x2="269.58"
          y2="68.75"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-18"
          data-name="linear gradient 3"
          cx="268.07"
          cy="1083.32"
          r="9.79"
          gradientTransform="translate(0 -894.6) scale(1 0.89)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138-3"
          x1="293.07"
          y1="82.51"
          x2="288.65"
          y2="59.22"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_138"
        />
        <radialGradient
          id="gradient_136-3"
          data-name="linear gradient 136"
          cx="288.48"
          cy="58.46"
          r="13.08"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-22"
          x1="-2746.61"
          y1="209.55"
          x2="-2746.71"
          y2="199.71"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_132-4"
          cx="-2752.36"
          cy="182.34"
          r="17.45"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_132"
        />
        <linearGradient
          id="gradient_137-23"
          x1="-2745.01"
          y1="183.86"
          x2="-2743.2"
          y2="157.46"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-19"
          data-name="linear gradient 3"
          cx="-2751.38"
          cy="2756.61"
          r="15.53"
          gradientTransform="matrix(-1, 0, 0, 0.76, -2365.93, -1930.16)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-24"
          x1="-2738.32"
          y1="156.62"
          x2="-2737.62"
          y2="133.83"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-20"
          data-name="linear gradient 3"
          cx="-2740.63"
          cy="2605.59"
          r="19.24"
          gradientTransform="matrix(-1, 0, 0, 0.77, -2365.93, -1867.23)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-25"
          x1="-2730.47"
          y1="128.56"
          x2="-2731.08"
          y2="108.79"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-21"
          data-name="linear gradient 3"
          cx="-2733.68"
          cy="5630.31"
          r="15.37"
          gradientTransform="matrix(-1, 0, 0, 0.59, -2365.93, -3233.4)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-26"
          x1="-2722.77"
          y1="112.07"
          x2="-2722.97"
          y2="94.5"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-22"
          data-name="linear gradient 3"
          cx="-2725.01"
          cy="4240.75"
          r="11.93"
          gradientTransform="matrix(-1, 0, 0, 0.66, -2365.93, -2706.05)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-27"
          x1="-2712.95"
          y1="96.18"
          x2="-2711.04"
          y2="77.81"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-23"
          data-name="linear gradient 3"
          cx="-2713.86"
          cy="75.74"
          r="12.02"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-28"
          x1="-2697.51"
          y1="85.01"
          x2="-2697.41"
          y2="68.75"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-24"
          data-name="linear gradient 3"
          cx="-2698.92"
          cy="1083.32"
          r="9.79"
          gradientTransform="matrix(-1, 0, 0, 0.89, -2365.93, -894.58)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138-4"
          x1="-2673.91"
          y1="82.51"
          x2="-2678.33"
          y2="59.22"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_138"
        />
        <radialGradient
          id="gradient_136-4"
          data-name="linear gradient 136"
          cx="-2678.5"
          cy="58.46"
          r="13.08"
          gradientTransform="matrix(-1, 0, 0, 1, -2365.93, 0)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-29"
          x1="68.06"
          y1="-4783.16"
          x2="69.54"
          y2="-4804.83"
          gradientTransform="matrix(0.99, -0.17, -0.17, -0.99, -617.67, -4462.81)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-25"
          data-name="linear gradient 3"
          cx="448.16"
          cy="-4352.41"
          r="8.68"
          gradientTransform="matrix(0.91, 0, 0, -1.18, -156.87, -4858.24)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-30"
          x1="-290.2"
          y1="-5095.71"
          x2="-288.74"
          y2="-5117.09"
          gradientTransform="matrix(0.95, -0.3, -0.3, -0.95, -985.12, -4686.42)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-26"
          data-name="linear gradient 3"
          cx="455.56"
          cy="-4371.82"
          r="8.45"
          gradientTransform="matrix(0.91, 0, 0, -1.18, -156.87, -4858.24)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-31"
          x1="674.84"
          y1="-4080.58"
          x2="676.55"
          y2="-4097.08"
          gradientTransform="matrix(0.99, 0.11, 0.11, -0.99, 59.93, -3847.64)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-27"
          data-name="linear gradient 3"
          cx="466.07"
          cy="-4385.86"
          r="6.34"
          gradientTransform="matrix(0.91, 0, 0, -1.18, -156.87, -4858.24)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-32"
          x1="473.51"
          y1="-4407.3"
          x2="473.6"
          y2="-4422.49"
          gradientTransform="matrix(1, 0, 0, -1, -195.05, -4113.33)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-28"
          data-name="linear gradient 3"
          cx="476.49"
          cy="-3942.4"
          r="7.78"
          gradientTransform="matrix(0.91, 0, 0, -1.04, -156.87, -3805.94)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138-5"
          x1="491.36"
          y1="-4409.77"
          x2="487.26"
          y2="-4431.39"
          gradientTransform="matrix(1, 0, 0, -1, -195.05, -4113.33)"
          xlink:href="#gradient_138"
        />
        <radialGradient
          id="gradient_136-5"
          data-name="linear gradient 136"
          cx="492.71"
          cy="-4401.11"
          r="10.39"
          gradientTransform="matrix(0.91, 0, 0, -1.18, -156.87, -4858.24)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-33"
          x1="-4888.85"
          y1="-3939.41"
          x2="-4887.36"
          y2="-3961.08"
          gradientTransform="translate(-3808.3 -4462.8) rotate(-170.3)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-29"
          data-name="linear gradient 3"
          cx="-4592.51"
          cy="-4352.41"
          r="8.68"
          gradientTransform="translate(-3835.6 -4858.2) rotate(180) scale(0.91 1.18)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-34"
          x1="-5089.71"
          y1="-3597.44"
          x2="-5088.25"
          y2="-3618.81"
          gradientTransform="translate(-3440.9 -4686.4) rotate(-162.7)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-30"
          data-name="linear gradient 3"
          cx="-4585.11"
          cy="-4371.82"
          r="8.45"
          gradientTransform="translate(-3835.6 -4858.2) rotate(180) scale(0.91 1.18)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-35"
          x1="-4320.69"
          y1="-4650.22"
          x2="-4318.98"
          y2="-4666.72"
          gradientTransform="translate(-4485.9 -3847.6) rotate(173.5)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-31"
          data-name="linear gradient 3"
          cx="-4574.59"
          cy="-4385.86"
          r="6.34"
          gradientTransform="translate(-3835.6 -4858.2) rotate(180) scale(0.91 1.18)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-36"
          x1="-4554.6"
          y1="-4407.3"
          x2="-4554.5"
          y2="-4422.49"
          gradientTransform="translate(-4231 -4113.3) rotate(180)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-32"
          data-name="linear gradient 3"
          cx="-4564.18"
          cy="-3942.4"
          r="7.78"
          gradientTransform="translate(-3835.6 -3805.9) rotate(180) scale(0.91 1.04)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138-6"
          x1="-4536.74"
          y1="-4409.77"
          x2="-4540.84"
          y2="-4431.39"
          gradientTransform="translate(-4231 -4113.3) rotate(180)"
          xlink:href="#gradient_138"
        />
        <radialGradient
          id="gradient_136-6"
          data-name="linear gradient 136"
          cx="-4547.96"
          cy="-4401.11"
          r="10.39"
          gradientTransform="translate(-3835.6 -4858.2) rotate(180) scale(0.91 1.18)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-37"
          x1="-3935.46"
          y1="520.73"
          x2="-3933.98"
          y2="499.08"
          gradientTransform="matrix(-0.99, 0.17, 0.17, 0.99, -3613.28, 349.49)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-33"
          data-name="linear gradient 3"
          cx="-4390.31"
          cy="171.43"
          r="8.68"
          gradientTransform="matrix(-1, 0, 0, 1.18, -4035.9, -19.72)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-38"
          x1="-3548.67"
          y1="695"
          x2="-3547.21"
          y2="673.63"
          gradientTransform="matrix(-0.95, 0.3, 0.3, 0.95, -3245.83, 573.1)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-34"
          data-name="linear gradient 3"
          cx="-4382.91"
          cy="152.02"
          r="8.45"
          gradientTransform="matrix(-1, 0, 0, 1.18, -4035.9, -19.72)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-39"
          x1="-4645.48"
          y1="-101.13"
          x2="-4643.76"
          y2="-117.63"
          gradientTransform="matrix(-0.99, -0.11, -0.11, 0.99, -4290.88, -265.69)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-35"
          data-name="linear gradient 3"
          cx="-4372.4"
          cy="137.99"
          r="6.34"
          gradientTransform="matrix(-1, 0, 0, 1.18, -4035.9, -19.72)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-40"
          x1="-4360.87"
          y1="149.47"
          x2="-4360.78"
          y2="134.28"
          gradientTransform="matrix(-1, 0, 0, 1, -4035.9, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-36"
          data-name="linear gradient 3"
          cx="-4361.98"
          cy="1153.74"
          r="7.78"
          gradientTransform="matrix(-1, 0, 0, 1.04, -4035.9, -1072.02)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138-7"
          x1="-4341.62"
          y1="147.04"
          x2="-4345.72"
          y2="125.38"
          gradientTransform="matrix(-1, 0, 0, 1, -4035.9, 0)"
          xlink:href="#gradient_138"
        />
        <radialGradient
          id="gradient_136-7"
          data-name="linear gradient 136"
          cx="-4345.77"
          cy="122.74"
          r="10.39"
          gradientTransform="matrix(-1, 0, 0, 1.18, -4035.9, -19.72)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-41"
          x1="635.18"
          y1="-257.27"
          x2="636.66"
          y2="-278.92"
          gradientTransform="translate(-422.6 349.5) rotate(9.7)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-37"
          data-name="linear gradient 3"
          cx="245.97"
          cy="171.43"
          r="8.68"
          gradientTransform="translate(0 -19.7) scale(1 1.18)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-42"
          x1="876.84"
          y1="-686.52"
          x2="878.3"
          y2="-707.9"
          gradientTransform="translate(-790.1 573.1) rotate(17.3)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-38"
          data-name="linear gradient 3"
          cx="253.37"
          cy="152.02"
          r="8.45"
          gradientTransform="translate(0 -19.7) scale(1 1.18)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-43"
          x1="-39.23"
          y1="424.12"
          x2="-37.51"
          y2="407.62"
          gradientTransform="translate(255 -265.7) rotate(-6.5)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-39"
          data-name="linear gradient 3"
          cx="263.88"
          cy="137.99"
          r="6.34"
          gradientTransform="translate(0 -19.7) scale(1 1.18)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_137-44"
          x1="275.41"
          y1="149.47"
          x2="275.5"
          y2="134.28"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_137"
        />
        <radialGradient
          id="gradient_3-40"
          data-name="linear gradient 3"
          cx="274.3"
          cy="1153.74"
          r="7.78"
          gradientTransform="translate(0 -1072) scale(1 1.04)"
          xlink:href="#gradient_137"
        />
        <linearGradient
          id="gradient_138-8"
          x1="294.66"
          y1="147.04"
          x2="290.56"
          y2="125.38"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlink:href="#gradient_138"
        />
        <radialGradient
          id="gradient_136-8"
          data-name="linear gradient 136"
          cx="290.51"
          cy="122.74"
          r="10.39"
          gradientTransform="translate(0 -19.7) scale(1 1.18)"
          xlink:href="#gradient_137"
        />
      </defs>

      <g id="BG">
        <path
          id="Q3BG"
          class="cls-1 lower fm"
          :class="{
            active: isContainSelected([93, 96, 97]),
            'is-hover': isHovered([93, 96, 97]),
            highlight: isContainHightlight([93, 96, 97]),
          }"
          d="M330.8,213.5h73.4a0,0,0,0,1,0,0V375.8a0,0,0,0,1,0,0H300.7a0,0,0,0,1,0,0V243.6a30.1,30.1,0,0,1,30.1-30.1Z"
          transform="translate(507.4 538.1) rotate(180)"
        />
        <path
          id="Q4BG"
          class="cls-1 lower fm"
          :class="{
            active: isContainSelected([94, 96, 97]),
            'is-hover': isHovered([94, 96, 97]),
            highlight: isContainHightlight([94, 96, 97]),
          }"
          d="M0,162.2H103.6a0,0,0,0,1,0,0V324.6a0,0,0,0,1,0,0H30.1A30.1,30.1,0,0,1,0,294.4V162.2A0,0,0,0,1,0,162.2Z"
        />
        <path
          id="Q2BG"
          class="cls-1 upper fm"
          :class="{
            active: isContainSelected([92, 95, 97]),
            'is-hover': isHovered([92, 95, 97]),
            highlight: isContainHightlight([92, 95, 97]),
          }"
          d="M300.7,51.3H404.2a0,0,0,0,1,0,0V213.6a0,0,0,0,1,0,0H330.8a30.1,30.1,0,0,1-30.1-30.1V51.3A0,0,0,0,1,300.7,51.3Z"
          transform="translate(507.4 213.6) rotate(-180)"
        />
        <path
          id="Q1BG"
          class="cls-1 upper fm"
          :class="{
            active: isContainSelected([91, 95, 97]),
            'is-hover': isHovered([91, 95, 97]),
            highlight: isContainHightlight([91, 95, 97]),
          }"
          d="M30.1,0h73.4a0,0,0,0,1,0,0V162.4a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V30.1A30.1,30.1,0,0,1,30.1,0Z"
        />
      </g>
      <g id="Teeth_diagram" data-name="Teeth diagram">
        <g id="Perm_lower" data-name="Perm lower">
          <path
            id="Gum_perm_lower"
            data-name="Gum perm lower"
            class="cls-2"
            d="M391.4,228.8a23.5,23.5,0,0,0-1.2-3,19.8,19.8,0,0,1-1-2.5,13.7,13.7,0,0,0-2.8-5.5c-2.2-2.4-5.4-2.8-8.4-3l-3.9-.2h-.9l-4.9.2h-.8c-15.2,1.5-18.6,16.5-20.9,29.8-2.8,16.5-8,33.5-16.8,47.6-6.6,10.6-16.6,21-29.3,21-28.2,0-41.2-42.3-45.5-65.5-1.4-7.7-1.6-16.6-6-23.3a21.5,21.5,0,0,0-15.6-9.6h-.8l-4.9-.2h-.9l-3.9.2c-3,.2-6.1.6-8.4,3a13.7,13.7,0,0,0-2.8,5.5,19.8,19.8,0,0,1-1,2.5,23.5,23.5,0,0,0-1.2,3,24.2,24.2,0,0,0-.6,5.1,10.7,10.7,0,0,0,1,4.2,14.2,14.2,0,0,0,2.2,3.9,9.2,9.2,0,0,0,4.4,2.7,7.3,7.3,0,0,0-1.5,1.6c-2.1,3-2,6.7-1.9,10.3a35.7,35.7,0,0,1,0,4c0,.4-.1.9-.2,1.4a11.3,11.3,0,0,0,.1,5.3c1.3,3.8,5.1,5.5,8.2,5.9h.1a14.3,14.3,0,0,0-3.2,7.3,13.8,13.8,0,0,0,.8,6.6,6.7,6.7,0,0,0,1.5,2.5h.1a2.8,2.8,0,0,1,.8,2.1,11.6,11.6,0,0,0,1.8,6.7,9.6,9.6,0,0,0,6,4,12.4,12.4,0,0,0-2.3,4.4,12,12,0,0,0,.4,7.5,11.1,11.1,0,0,0,4.7,5.5,10.8,10.8,0,0,0,5.2,1.4,11.3,11.3,0,0,0-1.5,6.2,11.1,11.1,0,0,0,2.5,6.5,10.7,10.7,0,0,0,8.2,3.8h.8a12.2,12.2,0,0,0-.6,1.8,11.7,11.7,0,0,0,1.4,9.3,14,14,0,0,0,9.8,6.4h2.2c.5,2.8,3.3,4.8,4.9,6h.2a30.7,30.7,0,0,0,3.5,2.2h.2a38.8,38.8,0,0,0,4,1.6,16.7,16.7,0,0,0,5.1.9h.8c1.5,2.2,4.4,3.2,6.4,3.9h.2a31.8,31.8,0,0,0,4.2,1.2h.2a40.8,40.8,0,0,0,4.6.3h.3a17.3,17.3,0,0,0,5.5-.8l.9-.4.9.4a17.3,17.3,0,0,0,5.5.8h.3a40.8,40.8,0,0,0,4.6-.3h.2a31.8,31.8,0,0,0,4.2-1.2h.2c2-.7,4.9-1.7,6.4-3.9h.8a16.7,16.7,0,0,0,5.1-.9,38.7,38.7,0,0,0,4-1.6h.2a30.6,30.6,0,0,0,3.5-2.2h.2c1.8-1.3,4.4-3.2,5-6h2.2a14,14,0,0,0,9.8-6.4,11.7,11.7,0,0,0,1.4-9.3,12.2,12.2,0,0,0-.6-1.8h.8a10.7,10.7,0,0,0,8.2-3.8,11.1,11.1,0,0,0,2.5-6.5,11.3,11.3,0,0,0-1.5-6.2,10.8,10.8,0,0,0,5.2-1.4,11.1,11.1,0,0,0,4.7-5.5,12,12,0,0,0,.4-7.5,12.4,12.4,0,0,0-2.3-4.4,9.6,9.6,0,0,0,6-4,11.6,11.6,0,0,0,1.8-6.7,2.8,2.8,0,0,1,.8-2.1h.1a6.7,6.7,0,0,0,1.5-2.5,13.8,13.8,0,0,0,.8-6.6,14.3,14.3,0,0,0-3.2-7.3h.1c3.1-.4,6.8-2.1,8.2-5.9a11.4,11.4,0,0,0,.1-5.4c-.1-.5-.1-1-.2-1.4a35.7,35.7,0,0,1,0-4c.1-3.6.3-7.3-1.9-10.3a7.3,7.3,0,0,0-1.5-1.6,9.2,9.2,0,0,0,4.4-2.7,14.2,14.2,0,0,0,2.2-3.9,10.7,10.7,0,0,0,1-4.3A24.2,24.2,0,0,0,391.4,228.8Z"
            transform="translate(-197.5 -51.3)"
          />
          <g
            id="_48"
            data-name="48"
            class="tooth"
            :class="{ active: isSelected(48), highlight: isHighlight(48) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-3"
              d="M226.7,217.4l-3.8.2c-2.6.2-5.1.5-6.7,2.2a11.4,11.4,0,0,0-2.1,4.4,22.5,22.5,0,0,1-1.2,2.9,20.7,20.7,0,0,0-1.1,2.7,22,22,0,0,0-.5,4.2,7.9,7.9,0,0,0,.7,3.1,11.7,11.7,0,0,0,1.7,3.1c1.3,1.5,3.5,2.4,6.5,2.5h.7a17.5,17.5,0,0,0,11.9-4.4,16.7,16.7,0,0,0,5.2-11.9c0-3.3-1.5-4.9-3.2-6.4a10.6,10.6,0,0,0-5.6-2.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-4"
              d="M231.9,237a16,16,0,0,1-10.9,4h-.6c-2.5-.1-4.4-.7-5.4-1.9a10.4,10.4,0,0,1-1.5-2.7,6.3,6.3,0,0,1-.6-2.4,21.1,21.1,0,0,1,.4-3.7,19.1,19.1,0,0,1,1-2.5,24.2,24.2,0,0,0,1.2-3.1,10.2,10.2,0,0,1,1.8-3.8c1.2-1.3,3.4-1.5,5.7-1.7l3.7-.2,2.5.2a9.2,9.2,0,0,1,4.9,2c1.6,1.4,2.7,2.5,2.6,5.1A15.1,15.1,0,0,1,231.9,237Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_47"
            data-name="47"
            class="tooth"
            :class="{ active: isSelected(47), highlight: isHighlight(47) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-5"
              d="M234.6,244.4a13.1,13.1,0,0,1,4.8,7.8,20.9,20.9,0,0,1-.1,8.1,10.2,10.2,0,0,1-5.2,7.2h-.1a31.8,31.8,0,0,1-5.1,1.8l-.6.2a22.2,22.2,0,0,1-6.2,1.2h-1.1c-2.2-.3-5.1-1.5-6-4.1a9.1,9.1,0,0,1,.1-3.9c.1-.6.2-1.1.2-1.6a37.8,37.8,0,0,0,0-4.4c-.1-3.2-.2-6.3,1.3-8.6s3.8-2.5,6.1-3.2l1.7-.6a18.9,18.9,0,0,1,6-1.1A6.4,6.4,0,0,1,234.6,244.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-6"
              d="M233.5,265.9h0a30.6,30.6,0,0,1-4.8,1.7l-.6.2a21.2,21.2,0,0,1-5.7,1.2h-.9c-1.9-.2-4.1-1.3-4.7-3a8.9,8.9,0,0,1,.1-3.1c.1-.6.2-1.1.2-1.7a39.1,39.1,0,0,0,0-4.6c-.1-3-.2-5.8,1-7.5s3.3-2,5.3-2.6l1.8-.6a17.3,17.3,0,0,1,5.6-1,4.7,4.7,0,0,1,2.9.8h.2a11.3,11.3,0,0,1,4.2,6.7,19.1,19.1,0,0,1-.1,7.4A8.5,8.5,0,0,1,233.5,265.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_46"
            data-name="46"
            class="tooth"
            :class="{ active: isSelected(46), highlight: isHighlight(46) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-7"
              d="M232.5,270.4a15.9,15.9,0,0,0-6.7,2.3,11.8,11.8,0,0,0-5.4,8.3,10.8,10.8,0,0,0,.6,5.1,4,4,0,0,0,.8,1.5h.1a5.7,5.7,0,0,1,1.8,4.2,8.7,8.7,0,0,0,1.3,5.1,7.4,7.4,0,0,0,7,3h.3c2.4-.4,4.8-1.7,7.5-4a14.9,14.9,0,0,0,3.6-4.2,15.9,15.9,0,0,0,2.1-5.8,22.6,22.6,0,0,0-.2-5.3,14.7,14.7,0,0,0-1.8-6.1,8.5,8.5,0,0,0-3.7-3.1A14.1,14.1,0,0,0,232.5,270.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-8"
              d="M242.1,290.9a13.4,13.4,0,0,1-3.2,3.8c-2.5,2.2-4.7,3.4-6.8,3.7h-1a5.8,5.8,0,0,1-4.8-2.4,7.1,7.1,0,0,1-1.1-4.2,7.3,7.3,0,0,0-2.3-5.4h0a2.6,2.6,0,0,1-.5-.9,9.1,9.1,0,0,1-.5-4.3,10.2,10.2,0,0,1,4.6-7.1,14.4,14.4,0,0,1,6.1-2.1h1.7a12,12,0,0,1,4.9,1,7,7,0,0,1,3,2.5,13.2,13.2,0,0,1,1.6,5.4,21,21,0,0,1,.2,4.9A14.3,14.3,0,0,1,242.1,290.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_45"
            data-name="45"
            class="tooth"
            :class="{ active: isSelected(45), highlight: isHighlight(45) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-9"
              d="M243.7,299a17.2,17.2,0,0,0-3.9.5,18.6,18.6,0,0,0-6.6,2.7,10.4,10.4,0,0,0-4.1,5.6,8.9,8.9,0,0,0,.3,5.6,8,8,0,0,0,7.6,5.2,10.4,10.4,0,0,0,3.6-.7,16.6,16.6,0,0,0,6.6-5,17,17,0,0,0,2.8-4.4,11.4,11.4,0,0,0,.7-2.3,5.6,5.6,0,0,0-1.3-4.8,7.1,7.1,0,0,0-2.2-1.6A8.4,8.4,0,0,0,243.7,299Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-10"
              d="M248.7,307.9a15.5,15.5,0,0,1-2.5,4,15.2,15.2,0,0,1-6,4.6,8.9,8.9,0,0,1-3.1.6,6.9,6.9,0,0,1-3.4-.8,6.7,6.7,0,0,1-2.9-3.3,7.2,7.2,0,0,1-.2-4.5,8.9,8.9,0,0,1,3.5-4.7,17.1,17.1,0,0,1,6-2.5,15.9,15.9,0,0,1,3.6-.5,7,7,0,0,1,3,.6,5.6,5.6,0,0,1,1.7,1.2,3.9,3.9,0,0,1,.9,3.4A9.7,9.7,0,0,1,248.7,307.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_44"
            data-name="44"
            class="tooth"
            :class="{ active: isSelected(44), highlight: isHighlight(44) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-11"
              d="M250.8,316.1a9.3,9.3,0,0,0-2.6.4,19.1,19.1,0,0,0-4.8,2.4,13.6,13.6,0,0,0-4.1,3.6,8.3,8.3,0,0,0,.4,9.8,8.1,8.1,0,0,0,6.2,2.9l1.8-.2a10.9,10.9,0,0,0,6.9-5.7,16,16,0,0,0,1.7-7.8,5.3,5.3,0,0,0-3-4.7h-.3A6.9,6.9,0,0,0,250.8,316.1Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-12"
              d="M247.5,333.3l-1.5.2a6.6,6.6,0,0,1-5.1-2.3,6.6,6.6,0,0,1-.3-7.8,12.3,12.3,0,0,1,3.6-3.2,17.8,17.8,0,0,1,4.4-2.2,7.9,7.9,0,0,1,2.2-.3,5.5,5.5,0,0,1,1.9.3h.2a3.7,3.7,0,0,1,2,3.3,14.3,14.3,0,0,1-1.5,7A9.4,9.4,0,0,1,247.5,333.3Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_43"
            data-name="43"
            class="tooth"
            :class="{ active: isSelected(43), highlight: isHighlight(43) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-13"
              d="M262.1,331.8a11.1,11.1,0,0,0-2.8.4,27.9,27.9,0,0,0-6.2,2.5,9.3,9.3,0,0,0-4.5,5.7c-1.7,6.1,3.6,11.4,8.9,12.1a5.4,5.4,0,0,0,3.7-.6,6.7,6.7,0,0,0,2.2-3.4,45,45,0,0,0,2.6-10.4c.2-1.6.3-3.7-.7-5a4,4,0,0,0-2.7-1.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-14"
              d="M262.1,348a5.6,5.6,0,0,1-1.6,2.6,3.1,3.1,0,0,1-1.7.4h-1a9.9,9.9,0,0,1-6.8-4.4,7,7,0,0,1-.8-5.6,7.7,7.7,0,0,1,3.7-4.7,26.5,26.5,0,0,1,5.8-2.4,9.7,9.7,0,0,1,2.4-.4h.5a2.5,2.5,0,0,1,1.7.8c.7.8.5,2.5.4,3.7A43.3,43.3,0,0,1,262.1,348Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_42"
            data-name="42"
            class="tooth"
            :class="{ active: isSelected(42), highlight: isHighlight(42) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-15"
              d="M276.5,343.5a5.9,5.9,0,0,0-4.4.5,17.9,17.9,0,0,0-4.5,3.3h-.2c-2,1.9-4.1,3.8-5.2,6.2a2.2,2.2,0,0,0-.2,1.2c.3,1.7,2.5,3.3,3.9,4.3h.2l3.2,2a36.3,36.3,0,0,0,3.7,1.5,14,14,0,0,0,4.6.8,1.4,1.4,0,0,0,1-.4,2.1,2.1,0,0,0,.3-.7,45.6,45.6,0,0,0,1.4-13.1,8.6,8.6,0,0,0-1.7-4.6,5,5,0,0,0-1.9-1.2Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-16"
              d="M277.3,362a12.9,12.9,0,0,1-3.9-.7l-3.5-1.4-2.9-1.9h-.2c-.9-.7-3-2.2-3.2-3.3a.6.6,0,0,1,.1-.3c.9-2.1,2.9-3.9,4.8-5.6h.2a16.5,16.5,0,0,1,4.1-3.1,5.2,5.2,0,0,1,2.2-.6l1.1.2h.1a3.5,3.5,0,0,1,1.4.9,7.3,7.3,0,0,1,1.2,3.6,44.4,44.4,0,0,1-1.3,12.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_41"
            data-name="41"
            class="tooth"
            :class="{ active: isSelected(41), highlight: isHighlight(41) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-17"
              d="M291.8,347.9a6.6,6.6,0,0,0-4.5,1.9,20.4,20.4,0,0,0-3.7,4.9v.2c-1.6,2.6-3.2,5.3-3.6,8.1a2.4,2.4,0,0,0,.2,1.4c.8,1.7,3.6,2.6,5.2,3.2h.2l3.9,1.1a38.5,38.5,0,0,0,4.3.3,15.1,15.1,0,0,0,5-.7,1.5,1.5,0,0,0,1-.8,2.4,2.4,0,0,0,.1-.8,49.3,49.3,0,0,0-2.3-14.1,9,9,0,0,0-3-4.2,5.3,5.3,0,0,0-2.3-.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-18"
              d="M293.9,367.4h-.2l-4.1-.3-3.6-1h-.2c-1.1-.4-3.8-1.3-4.4-2.4a.7.7,0,0,1,0-.4c.4-2.5,1.9-5,3.4-7.5v-.2a18.9,18.9,0,0,1,3.4-4.6,5.2,5.2,0,0,1,3.4-1.5h.1a3.8,3.8,0,0,1,1.7.5,7.8,7.8,0,0,1,2.3,3.4,48.2,48.2,0,0,1,2.2,13.5A13.5,13.5,0,0,1,293.9,367.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_38"
            data-name="38"
            class="tooth"
            :class="{ active: isSelected(38), highlight: isHighlight(38) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-19"
              d="M374.1,217.4l3.8.2c2.6.2,5.1.5,6.7,2.2a11.4,11.4,0,0,1,2.1,4.4,22.4,22.4,0,0,0,1.2,2.9,20.7,20.7,0,0,1,1.1,2.7,22,22,0,0,1,.5,4.2,7.9,7.9,0,0,1-.7,3.1,11.7,11.7,0,0,1-1.7,3.1c-1.3,1.5-3.5,2.4-6.5,2.5h-.7a17.5,17.5,0,0,1-11.9-4.4,16.7,16.7,0,0,1-5.2-11.9c0-3.3,1.5-4.9,3.2-6.4a10.6,10.6,0,0,1,5.6-2.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-20"
              d="M368.8,237a16,16,0,0,0,10.9,4h.6c2.5-.1,4.4-.7,5.4-1.9a10.5,10.5,0,0,0,1.5-2.7,6.3,6.3,0,0,0,.6-2.4,21.1,21.1,0,0,0-.4-3.7,19.1,19.1,0,0,0-1-2.5,24.2,24.2,0,0,1-1.2-3.1,10.2,10.2,0,0,0-1.8-3.8c-1.2-1.3-3.4-1.5-5.7-1.7l-3.7-.2-2.5.2a9.2,9.2,0,0,0-4.9,2c-1.6,1.4-2.7,2.5-2.6,5.1A15.1,15.1,0,0,0,368.8,237Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_37"
            data-name="37"
            class="tooth"
            :class="{ active: isSelected(37), highlight: isHighlight(37) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-21"
              d="M366.1,244.4a13.1,13.1,0,0,0-4.8,7.8,20.9,20.9,0,0,0,.1,8.1,10.2,10.2,0,0,0,5.2,7.2h.1a31.8,31.8,0,0,0,5.1,1.8l.6.2a22.2,22.2,0,0,0,6.2,1.2h1.1c2.2-.3,5.1-1.5,6-4.1a9.1,9.1,0,0,0-.1-3.9c-.1-.6-.2-1.1-.2-1.6a37.8,37.8,0,0,1,0-4.4c.1-3.2.2-6.3-1.3-8.6s-3.8-2.5-6.1-3.2l-1.7-.6a18.9,18.9,0,0,0-6-1.1A6.4,6.4,0,0,0,366.1,244.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-22"
              d="M367.2,265.9h0a30.6,30.6,0,0,0,4.8,1.7l.6.2a21.1,21.1,0,0,0,5.7,1.2h.9c1.9-.2,4.1-1.3,4.7-3a8.9,8.9,0,0,0-.1-3.1c-.1-.6-.2-1.1-.2-1.7a39.1,39.1,0,0,1,0-4.6c.1-3,.2-5.8-1-7.5s-3.3-2-5.3-2.6l-1.8-.6a17.3,17.3,0,0,0-5.6-1,4.7,4.7,0,0,0-2.9.8H367a11.3,11.3,0,0,0-4.2,6.7,19.1,19.1,0,0,0,.1,7.4A8.5,8.5,0,0,0,367.2,265.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_36"
            data-name="36"
            class="tooth"
            :class="{ active: isSelected(36), highlight: isHighlight(36) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-23"
              d="M368.2,270.4a15.9,15.9,0,0,1,6.7,2.3,11.8,11.8,0,0,1,5.4,8.3,10.8,10.8,0,0,1-.6,5.1,4,4,0,0,1-.8,1.5h-.1a5.7,5.7,0,0,0-1.8,4.2,8.7,8.7,0,0,1-1.3,5.1,7.4,7.4,0,0,1-7,3h-.3c-2.4-.4-4.8-1.7-7.5-4a14.9,14.9,0,0,1-3.6-4.2,15.9,15.9,0,0,1-2.1-5.8,22.6,22.6,0,0,1,.2-5.3,14.7,14.7,0,0,1,1.8-6.1,8.5,8.5,0,0,1,3.7-3.1A14.1,14.1,0,0,1,368.2,270.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-24"
              d="M358.6,290.9a13.4,13.4,0,0,0,3.2,3.8c2.5,2.2,4.7,3.4,6.8,3.7h1a5.8,5.8,0,0,0,4.8-2.4,7.1,7.1,0,0,0,1.1-4.2,7.3,7.3,0,0,1,2.3-5.4h0a2.6,2.6,0,0,0,.5-.9,9.1,9.1,0,0,0,.5-4.3,10.2,10.2,0,0,0-4.6-7.1,14.4,14.4,0,0,0-6.1-2.1h-1.7a12,12,0,0,0-4.9,1,7,7,0,0,0-3,2.5,13.2,13.2,0,0,0-1.6,5.4,21,21,0,0,0-.2,4.9A14.3,14.3,0,0,0,358.6,290.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_35"
            data-name="35"
            class="tooth"
            :class="{ active: isSelected(35), highlight: isHighlight(35) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-25"
              d="M357,299a17.2,17.2,0,0,1,3.9.5,18.6,18.6,0,0,1,6.6,2.7,10.4,10.4,0,0,1,4.1,5.6,8.9,8.9,0,0,1-.3,5.6,8,8,0,0,1-7.6,5.2,10.4,10.4,0,0,1-3.6-.7,16.6,16.6,0,0,1-6.6-5,17,17,0,0,1-2.8-4.4,11.4,11.4,0,0,1-.7-2.3,5.6,5.6,0,0,1,1.3-4.8,7.1,7.1,0,0,1,2.2-1.6A8.4,8.4,0,0,1,357,299Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-26"
              d="M352.1,307.9a15.5,15.5,0,0,0,2.5,4,15.2,15.2,0,0,0,6,4.6,8.9,8.9,0,0,0,3.1.6,6.9,6.9,0,0,0,3.4-.8,6.7,6.7,0,0,0,2.9-3.3,7.2,7.2,0,0,0,.2-4.5,8.9,8.9,0,0,0-3.5-4.7,17.1,17.1,0,0,0-6-2.5,15.9,15.9,0,0,0-3.6-.5,7,7,0,0,0-3,.6,5.6,5.6,0,0,0-1.7,1.2,3.9,3.9,0,0,0-.9,3.4A9.7,9.7,0,0,0,352.1,307.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_34"
            data-name="34"
            class="tooth"
            :class="{ active: isSelected(34), highlight: isHighlight(34) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-27"
              d="M349.9,316.1a9.3,9.3,0,0,1,2.6.4,19.1,19.1,0,0,1,4.8,2.4,13.6,13.6,0,0,1,4.1,3.6,8.3,8.3,0,0,1-.4,9.8,8.1,8.1,0,0,1-6.2,2.9l-1.8-.2a10.9,10.9,0,0,1-6.9-5.7,16,16,0,0,1-1.7-7.8,5.3,5.3,0,0,1,3-4.7h.3A6.9,6.9,0,0,1,349.9,316.1Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-28"
              d="M353.2,333.3l1.5.2a6.6,6.6,0,0,0,5.1-2.3,6.6,6.6,0,0,0,.3-7.8,12.3,12.3,0,0,0-3.6-3.2,17.8,17.8,0,0,0-4.4-2.2,7.9,7.9,0,0,0-2.2-.3,5.5,5.5,0,0,0-1.9.3h-.2a3.7,3.7,0,0,0-2,3.3,14.3,14.3,0,0,0,1.5,7A9.4,9.4,0,0,0,353.2,333.3Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_33"
            data-name="33"
            class="tooth"
            :class="{ active: isSelected(33), highlight: isHighlight(33) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-29"
              d="M338.6,331.8a11.1,11.1,0,0,1,2.8.4,27.9,27.9,0,0,1,6.2,2.5,9.3,9.3,0,0,1,4.5,5.7c1.7,6.1-3.6,11.4-8.9,12.1a5.4,5.4,0,0,1-3.7-.6,6.7,6.7,0,0,1-2.2-3.4,45,45,0,0,1-2.6-10.4c-.2-1.6-.3-3.7.7-5a4,4,0,0,1,2.7-1.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-30"
              d="M338.6,348a5.6,5.6,0,0,0,1.6,2.6,3.1,3.1,0,0,0,1.7.4h1a9.9,9.9,0,0,0,6.8-4.4,7,7,0,0,0,.8-5.6,7.7,7.7,0,0,0-3.7-4.7,26.5,26.5,0,0,0-5.8-2.4,9.7,9.7,0,0,0-2.4-.4h-.5a2.5,2.5,0,0,0-1.7.8c-.7.8-.5,2.5-.4,3.7A43.3,43.3,0,0,0,338.6,348Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_32"
            data-name="32"
            class="tooth"
            :class="{ active: isSelected(32), highlight: isHighlight(32) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-31"
              d="M324.2,343.5a5.9,5.9,0,0,1,4.4.5,17.9,17.9,0,0,1,4.5,3.3h.2c2,1.9,4.1,3.8,5.2,6.2a2.2,2.2,0,0,1,.2,1.2c-.3,1.7-2.5,3.3-3.9,4.3h-.2l-3.2,2a36.3,36.3,0,0,1-3.7,1.5,14,14,0,0,1-4.6.8,1.4,1.4,0,0,1-1-.4,2.1,2.1,0,0,1-.3-.7,45.6,45.6,0,0,1-1.4-13.1,8.6,8.6,0,0,1,1.7-4.6,5,5,0,0,1,1.9-1.2Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-32"
              d="M323.4,362a12.9,12.9,0,0,0,3.9-.7l3.5-1.4,2.9-1.9h.2c.9-.7,3-2.2,3.2-3.3a.6.6,0,0,0-.1-.3c-.9-2.1-2.9-3.9-4.8-5.6h-.2a16.5,16.5,0,0,0-4.1-3.1,5.2,5.2,0,0,0-2.2-.6l-1.1.2h-.1a3.5,3.5,0,0,0-1.4.9,7.3,7.3,0,0,0-1.2,3.6,44.4,44.4,0,0,0,1.3,12.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_31"
            data-name="31"
            class="tooth"
            :class="{ active: isSelected(31), highlight: isHighlight(31) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-33"
              d="M308.9,347.9a6.6,6.6,0,0,1,4.5,1.9,20.4,20.4,0,0,1,3.7,4.9v.2c1.6,2.6,3.2,5.3,3.6,8.1a2.4,2.4,0,0,1-.2,1.4c-.8,1.7-3.6,2.6-5.2,3.2h-.2l-3.9,1.1a38.5,38.5,0,0,1-4.3.3,15.1,15.1,0,0,1-5-.7,1.5,1.5,0,0,1-1-.8,2.4,2.4,0,0,1-.1-.8,49.3,49.3,0,0,1,2.3-14.1,9,9,0,0,1,3-4.2,5.3,5.3,0,0,1,2.3-.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-34"
              d="M306.8,367.4h.2l4.1-.3,3.6-1h.2c1.1-.4,3.8-1.3,4.4-2.4a.7.7,0,0,0,0-.4c-.4-2.5-1.9-5-3.4-7.5v-.2a18.9,18.9,0,0,0-3.4-4.6,5.2,5.2,0,0,0-3.4-1.5h-.1a3.8,3.8,0,0,0-1.7.5,7.8,7.8,0,0,0-2.3,3.4,48.2,48.2,0,0,0-2.2,13.5A13.5,13.5,0,0,0,306.8,367.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
        </g>
        <g id="Perm_upper" data-name="Perm upper">
          <path
            id="Gum_perm_upper"
            data-name="Gum perm upper"
            class="cls-2"
            d="M396.8,189.6a14,14,0,0,0-2.3-3.9,9.9,9.9,0,0,0-4.7-2.7,7.5,7.5,0,0,0,1.6-1.6c2.3-3,2.1-6.7,2-10.3a33.6,33.6,0,0,1,0-4c0-.4.1-.9.2-1.4a10.7,10.7,0,0,0-.1-5.3c-1.4-3.8-5.4-5.5-8.7-5.9h-.1a13.9,13.9,0,0,0,3.4-7.3,13.1,13.1,0,0,0-.8-6.6,6.6,6.6,0,0,0-1.6-2.5h-.1a2.7,2.7,0,0,1-.9-2.1,11,11,0,0,0-1.9-6.7,10.2,10.2,0,0,0-6.3-4,12.2,12.2,0,0,0,2.5-4.4,11.1,11.1,0,0,0-5.4-13,12,12,0,0,0-5.5-1.4,10.7,10.7,0,0,0-1-12.7,11.7,11.7,0,0,0-8.7-3.8h-.8a11.8,11.8,0,0,0,.7-1.8,11.1,11.1,0,0,0-1.4-9.3,15,15,0,0,0-10.4-6.4h-2.4c-.6-2.8-3.5-4.8-5.3-6h-.2a33,33,0,0,0-3.7-2.2h-.2a42.7,42.7,0,0,0-4.2-1.6,18.7,18.7,0,0,0-5.4-.9h-.8c-1.6-2.2-4.7-3.2-6.8-3.9h-.2a35.4,35.4,0,0,0-4.5-1.2h-.2a46,46,0,0,0-4.9-.3h-.3a19.4,19.4,0,0,0-5.9.8l-1,.4-1-.4a19.4,19.4,0,0,0-5.9-.8h-.3a46,46,0,0,0-4.9.3h-.2a35.5,35.5,0,0,0-4.5,1.2h-.2c-2.1.7-5.2,1.7-6.8,3.9h-.8a18.7,18.7,0,0,0-5.4.9,42.7,42.7,0,0,0-4.2,1.6h-.2a32.9,32.9,0,0,0-3.7,2.2h-.2c-1.9,1.3-4.7,3.2-5.3,6h-2.4a15,15,0,0,0-10.4,6.4,11.1,11.1,0,0,0-1.4,9.3,11.7,11.7,0,0,0,.7,1.8h-.8a11.7,11.7,0,0,0-8.7,3.8,10.7,10.7,0,0,0-1,12.7,12,12,0,0,0-5.5,1.4,11.1,11.1,0,0,0-5.4,13,12.2,12.2,0,0,0,2.5,4.4,10.2,10.2,0,0,0-6.3,4,11,11,0,0,0-1.9,6.7,2.7,2.7,0,0,1-.9,2.1h-.1a6.6,6.6,0,0,0-1.6,2.5,13.1,13.1,0,0,0-.8,6.6,13.9,13.9,0,0,0,3.4,7.3h-.1c-3.3.4-7.3,2.1-8.7,5.9a10.7,10.7,0,0,0-.1,5.4c.1.5.2,1,.2,1.4a33.6,33.6,0,0,1,0,4c-.1,3.6-.3,7.3,2,10.3a7.5,7.5,0,0,0,1.6,1.6,9.9,9.9,0,0,0-4.7,2.7,14,14,0,0,0-2.3,3.9,10.2,10.2,0,0,0-1,4.3,15.7,15.7,0,0,0,2,8.1,19.2,19.2,0,0,1,1.1,2.5,13.4,13.4,0,0,0,3,5.5c2.4,2.4,5.7,2.8,8.9,3l4.2.2h1a93.1,93.1,0,0,0,44.8-11.8c8.2-4.5,19.7-7.3,32.4-7.3s24.3,2.8,32.4,7.3a93.1,93.1,0,0,0,44.8,11.8h1l4.2-.2c3.2-.2,6.5-.6,8.9-3a13.4,13.4,0,0,0,3-5.5,19.1,19.1,0,0,1,1.1-2.5,15.7,15.7,0,0,0,2-8.1A10.2,10.2,0,0,0,396.8,189.6Z"
            transform="translate(-197.5 -51.3)"
          />
          <g
            id="_18"
            data-name="18"
            class="tooth"
            :class="{ active: isSelected(18), highlight: isHighlight(18) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-35"
              d="M222.3,210.3l-4-.2c-2.8-.2-5.4-.5-7.1-2.2a11.1,11.1,0,0,1-2.3-4.4,21.7,21.7,0,0,0-1.2-2.9,20.1,20.1,0,0,1-1.1-2.7,20.7,20.7,0,0,1-.5-4.2,7.5,7.5,0,0,1,.8-3.1,11.5,11.5,0,0,1,1.8-3.1c1.4-1.5,3.7-2.4,6.9-2.5h.7a19.2,19.2,0,0,1,12.7,4.4,16.3,16.3,0,0,1,5.6,11.9c0,3.3-1.6,4.9-3.4,6.4a11.7,11.7,0,0,1-6,2.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-36"
              d="M227.9,190.7a17.6,17.6,0,0,0-11.6-4h-.7c-2.7.1-4.6.7-5.7,1.9a10.3,10.3,0,0,0-1.6,2.7,6,6,0,0,0-.7,2.4,19.9,19.9,0,0,0,.5,3.7,18.5,18.5,0,0,0,1.1,2.5,23.4,23.4,0,0,1,1.3,3.1,10,10,0,0,0,1.9,3.8c1.3,1.3,3.6,1.5,6.1,1.7l3.9.2,2.6-.2a10.1,10.1,0,0,0,5.2-2c1.7-1.4,2.8-2.5,2.8-5.1A14.7,14.7,0,0,0,227.9,190.7Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_17"
            data-name="17"
            class="tooth"
            :class="{ active: isSelected(17), highlight: isHighlight(17) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-37"
              d="M230.7,183.4a13,13,0,0,0,5.1-7.8,19.7,19.7,0,0,0-.1-8.1,10.2,10.2,0,0,0-5.5-7.2h-.1a35.1,35.1,0,0,0-5.4-1.8l-.7-.2a24.8,24.8,0,0,0-6.5-1.2h-1.1c-2.3.3-5.4,1.5-6.4,4.1a8.6,8.6,0,0,0,.1,3.9c.1.6.2,1.1.2,1.6a35.6,35.6,0,0,1,0,4.4c-.1,3.2-.2,6.3,1.4,8.6s4,2.5,6.4,3.2l1.9.6a21.1,21.1,0,0,0,6.4,1.1A7.1,7.1,0,0,0,230.7,183.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-38"
              d="M229.6,161.8h0a33.8,33.8,0,0,0-5.1-1.7l-.7-.2a23.7,23.7,0,0,0-6.1-1.2h-1c-2,.2-4.4,1.3-5,3a8.4,8.4,0,0,0,.2,3.1c.1.6.2,1.1.2,1.7a36.9,36.9,0,0,1,0,4.6c-.1,3-.2,5.8,1.1,7.5s3.5,2,5.6,2.6l1.9.6a19.4,19.4,0,0,0,5.9,1,5.2,5.2,0,0,0,3.1-.8h.2c2.6-2.1,3.9-4.2,4.4-6.7a18,18,0,0,0-.1-7.4A8.6,8.6,0,0,0,229.6,161.8Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_16"
            data-name="16"
            class="tooth"
            :class="{ active: isSelected(16), highlight: isHighlight(16) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-39"
              d="M228.5,157.4a17.6,17.6,0,0,1-7.1-2.3,11.8,11.8,0,0,1-5.7-8.3,10.2,10.2,0,0,1,.6-5.1,4,4,0,0,1,.9-1.5h.1a5.5,5.5,0,0,0,1.9-4.2,8.3,8.3,0,0,1,1.4-5.1,8,8,0,0,1,7.4-3h.3c2.5.4,5.1,1.7,8,4a15.1,15.1,0,0,1,3.8,4.2,15.3,15.3,0,0,1,2.2,5.8,21.3,21.3,0,0,1-.2,5.3,14.1,14.1,0,0,1-1.9,6.1,8.9,8.9,0,0,1-3.9,3.1A15.8,15.8,0,0,1,228.5,157.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-40"
              d="M238.7,136.8a13.6,13.6,0,0,0-3.4-3.8c-2.6-2.2-5-3.4-7.2-3.7h-1a6.3,6.3,0,0,0-5.1,2.4,6.8,6.8,0,0,0-1.1,4.2,7.1,7.1,0,0,1-2.4,5.4h0a2.5,2.5,0,0,0-.5.9,8.6,8.6,0,0,0-.5,4.3,10.1,10.1,0,0,0,4.9,7.1,15.9,15.9,0,0,0,6.4,2.1h1.8a13.4,13.4,0,0,0,5.2-1,7.3,7.3,0,0,0,3.2-2.5,12.7,12.7,0,0,0,1.7-5.4,19.8,19.8,0,0,0,.2-4.9A13.8,13.8,0,0,0,238.7,136.8Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_15"
            data-name="15"
            class="tooth"
            :class="{ active: isSelected(15), highlight: isHighlight(15) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-41"
              d="M240.4,128.7a19.4,19.4,0,0,1-4.1-.5,20.4,20.4,0,0,1-7-2.7,10.5,10.5,0,0,1-4.4-5.6,8.3,8.3,0,0,1,4.1-9.7,9.3,9.3,0,0,1,4.3-1,11.6,11.6,0,0,1,3.9.7,17.6,17.6,0,0,1,7,5,16.9,16.9,0,0,1,3,4.4,10.9,10.9,0,0,1,.7,2.3,5.3,5.3,0,0,1-1.4,4.8,7.5,7.5,0,0,1-2.3,1.6A9.4,9.4,0,0,1,240.4,128.7Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-42"
              d="M245.7,119.9a15.4,15.4,0,0,0-2.7-4,16.1,16.1,0,0,0-6.4-4.6,10,10,0,0,0-3.3-.6,7.7,7.7,0,0,0-3.6.8,6.7,6.7,0,0,0-3.3,7.8,8.9,8.9,0,0,0,3.8,4.7,18.8,18.8,0,0,0,6.4,2.5,17.8,17.8,0,0,0,3.8.5,7.8,7.8,0,0,0,3.2-.6,5.9,5.9,0,0,0,1.8-1.2,3.7,3.7,0,0,0,1-3.4A9.3,9.3,0,0,0,245.7,119.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_14"
            data-name="14"
            class="tooth"
            :class="{ active: isSelected(14), highlight: isHighlight(14) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-43"
              d="M247.9,111.7a10.4,10.4,0,0,1-2.8-.4,20.8,20.8,0,0,1-5.1-2.4,14.2,14.2,0,0,1-4.3-3.6,7.9,7.9,0,0,1,.5-9.8,8.8,8.8,0,0,1,6.6-2.9l2,.2a11.5,11.5,0,0,1,7.4,5.7,15.2,15.2,0,0,1,1.8,7.8,5.3,5.3,0,0,1-3.2,4.7h-.3A7.7,7.7,0,0,1,247.9,111.7Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-44"
              d="M244.4,94.4l-1.6-.2a7.2,7.2,0,0,0-5.4,2.3,6.3,6.3,0,0,0-.4,7.8,12.8,12.8,0,0,0,3.9,3.2,19.4,19.4,0,0,0,4.7,2.2,8.8,8.8,0,0,0,2.3.3,6.1,6.1,0,0,0,2-.3h.2a3.6,3.6,0,0,0,2.2-3.3,13.6,13.6,0,0,0-1.6-7A9.9,9.9,0,0,0,244.4,94.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_13"
            data-name="13"
            class="tooth"
            :class="{ active: isSelected(13), highlight: isHighlight(13) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-45"
              d="M259.9,95.9a12.4,12.4,0,0,1-3-.4,30.7,30.7,0,0,1-6.6-2.5,9.4,9.4,0,0,1-4.7-5.7c-1.8-6.1,3.8-11.4,9.5-12.1a6,6,0,0,1,3.9.6,6.7,6.7,0,0,1,2.3,3.4,42.9,42.9,0,0,1,2.8,10.4c.2,1.6.3,3.7-.8,5a4.3,4.3,0,0,1-2.9,1.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-46"
              d="M259.9,79.7a5.6,5.6,0,0,0-1.7-2.6,3.5,3.5,0,0,0-1.8-.4h-1.1a10.6,10.6,0,0,0-7.2,4.4,6.7,6.7,0,0,0-.9,5.6,7.8,7.8,0,0,0,3.9,4.7,29.1,29.1,0,0,0,6.2,2.4,10.9,10.9,0,0,0,2.6.4h.5a2.8,2.8,0,0,0,1.8-.8c.7-.8.6-2.5.4-3.7A41.3,41.3,0,0,0,259.9,79.7Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_12"
            data-name="12"
            class="tooth"
            :class="{ active: isSelected(12), highlight: isHighlight(12) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-47"
              d="M275.2,84.2a6.6,6.6,0,0,1-4.7-.5,19,19,0,0,1-4.8-3.3h-.2c-2.2-1.9-4.4-3.8-5.5-6.2a2.1,2.1,0,0,1-.2-1.2c.3-1.7,2.7-3.3,4.1-4.3h.2l3.4-2a40,40,0,0,1,4-1.5,15.7,15.7,0,0,1,4.8-.8,1.5,1.5,0,0,1,1.1.4,2.1,2.1,0,0,1,.3.7,43.1,43.1,0,0,1,1.5,13.1,8.4,8.4,0,0,1-1.8,4.6,5.4,5.4,0,0,1-2,1.2Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-48"
              d="M276.1,65.8a14.5,14.5,0,0,0-4.2.7l-3.7,1.4-3.1,1.9h-.2c-1,.7-3.2,2.2-3.4,3.3a.5.5,0,0,0,.1.3c1,2.1,3.1,3.9,5.1,5.6h.2a17.5,17.5,0,0,0,4.4,3.1,5.8,5.8,0,0,0,2.4.6l1.2-.2h.1a3.8,3.8,0,0,0,1.4-.9,7.1,7.1,0,0,0,1.3-3.6,41.9,41.9,0,0,0-1.4-12.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_11"
            data-name="11"
            class="tooth"
            :class="{ active: isSelected(11), highlight: isHighlight(11) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-49"
              d="M291.4,79.9a7.2,7.2,0,0,1-4.7-1.9,20.6,20.6,0,0,1-4-4.9v-.2c-1.7-2.6-3.4-5.3-3.8-8.1a2.2,2.2,0,0,1,.2-1.4c.9-1.7,3.8-2.6,5.6-3.2h.2l4.1-1.1a43.4,43.4,0,0,1,4.6-.3,17,17,0,0,1,5.3.7,1.6,1.6,0,0,1,1,.8,2.2,2.2,0,0,1,.1.8A46.7,46.7,0,0,1,297.3,75a9.1,9.1,0,0,1-3.2,4.2,5.8,5.8,0,0,1-2.5.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-50"
              d="M293.7,60.3h-.2l-4.3.3-3.9,1H285c-1.2.4-4.1,1.3-4.6,2.4a.7.7,0,0,0,0,.4c.4,2.5,2,5,3.6,7.5v.2a19,19,0,0,0,3.6,4.6,5.6,5.6,0,0,0,3.6,1.5h.1a4.3,4.3,0,0,0,1.8-.5,7.8,7.8,0,0,0,2.5-3.4,45.6,45.6,0,0,0,2.4-13.5A15.1,15.1,0,0,0,293.7,60.3Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_28"
            data-name="28"
            class="tooth"
            :class="{ active: isSelected(28), highlight: isHighlight(28) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-51"
              d="M378.8,210.3l4-.2c2.8-.2,5.4-.5,7.1-2.2a11.1,11.1,0,0,0,2.3-4.4,21.7,21.7,0,0,1,1.2-2.9,20.1,20.1,0,0,0,1.1-2.7,20.8,20.8,0,0,0,.5-4.2,7.5,7.5,0,0,0-.8-3.1,11.5,11.5,0,0,0-1.8-3.1c-1.4-1.5-3.7-2.4-6.9-2.5h-.7a19.2,19.2,0,0,0-12.7,4.4,16.3,16.3,0,0,0-5.6,11.9c0,3.3,1.6,4.9,3.4,6.4a11.7,11.7,0,0,0,6,2.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-52"
              d="M373.2,190.7a17.6,17.6,0,0,1,11.6-4h.7c2.7.1,4.6.7,5.7,1.9a10.3,10.3,0,0,1,1.6,2.7,6,6,0,0,1,.7,2.4,19.9,19.9,0,0,1-.5,3.7,18.5,18.5,0,0,1-1.1,2.5,23.4,23.4,0,0,0-1.3,3.1,10,10,0,0,1-1.9,3.8c-1.3,1.3-3.6,1.5-6.1,1.7l-3.9.2-2.6-.2a10.1,10.1,0,0,1-5.2-2c-1.7-1.4-2.8-2.5-2.8-5.1A14.7,14.7,0,0,1,373.2,190.7Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_27"
            data-name="27"
            class="tooth"
            :class="{ active: isSelected(27), highlight: isHighlight(27) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-53"
              d="M370.3,183.4a13,13,0,0,1-5.1-7.8,19.7,19.7,0,0,1,.1-8.1,10.2,10.2,0,0,1,5.5-7.2h.1a35.1,35.1,0,0,1,5.4-1.8l.7-.2a24.8,24.8,0,0,1,6.5-1.2h1.1c2.3.3,5.4,1.5,6.4,4.1a8.6,8.6,0,0,1-.1,3.9c-.1.6-.2,1.1-.2,1.6a35.6,35.6,0,0,0,0,4.4c.1,3.2.2,6.3-1.4,8.6s-4,2.5-6.4,3.2l-1.9.6a21.1,21.1,0,0,1-6.4,1.1A7.1,7.1,0,0,1,370.3,183.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-54"
              d="M371.5,161.8h0a33.8,33.8,0,0,1,5.1-1.7l.7-.2a23.7,23.7,0,0,1,6.1-1.2h1c2,.2,4.4,1.3,5,3a8.4,8.4,0,0,1-.2,3.1c-.1.6-.2,1.1-.2,1.7a36.9,36.9,0,0,0,0,4.6c.1,3,.2,5.8-1.1,7.5s-3.5,2-5.6,2.6l-1.9.6a19.4,19.4,0,0,1-5.9,1,5.2,5.2,0,0,1-3.1-.8h-.2c-2.6-2.1-3.9-4.2-4.4-6.7a18,18,0,0,1,.1-7.4A8.6,8.6,0,0,1,371.5,161.8Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_26"
            data-name="26"
            class="tooth"
            :class="{ active: isSelected(26), highlight: isHighlight(26) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-55"
              d="M372.6,157.4a17.6,17.6,0,0,0,7.1-2.3,11.8,11.8,0,0,0,5.7-8.3,10.2,10.2,0,0,0-.6-5.1,4,4,0,0,0-.9-1.5h-.1a5.5,5.5,0,0,1-1.9-4.2,8.3,8.3,0,0,0-1.4-5.1,8,8,0,0,0-7.4-3h-.3c-2.5.4-5.1,1.7-8,4a15.1,15.1,0,0,0-3.8,4.2,15.3,15.3,0,0,0-2.2,5.8,21.3,21.3,0,0,0,.2,5.3,14.1,14.1,0,0,0,1.9,6.1,8.9,8.9,0,0,0,3.9,3.1A15.8,15.8,0,0,0,372.6,157.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-56"
              d="M362.4,136.8a13.6,13.6,0,0,1,3.4-3.8c2.6-2.2,5-3.4,7.2-3.7h1a6.3,6.3,0,0,1,5.1,2.4,6.8,6.8,0,0,1,1.1,4.2,7.1,7.1,0,0,0,2.4,5.4h0a2.5,2.5,0,0,1,.5.9,8.6,8.6,0,0,1,.5,4.3,10.1,10.1,0,0,1-4.9,7.1,15.9,15.9,0,0,1-6.4,2.1h-1.8a13.4,13.4,0,0,1-5.2-1,7.3,7.3,0,0,1-3.2-2.5,12.7,12.7,0,0,1-1.7-5.4,19.8,19.8,0,0,1-.2-4.9A13.8,13.8,0,0,1,362.4,136.8Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_25"
            data-name="25"
            class="tooth"
            :class="{ active: isSelected(25), highlight: isHighlight(25) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-57"
              d="M360.7,128.7a19.4,19.4,0,0,0,4.1-.5,20.4,20.4,0,0,0,7-2.7,10.5,10.5,0,0,0,4.4-5.6,8.3,8.3,0,0,0-4.1-9.7,9.3,9.3,0,0,0-4.3-1,11.6,11.6,0,0,0-3.9.7,17.6,17.6,0,0,0-7,5,16.9,16.9,0,0,0-3,4.4,10.9,10.9,0,0,0-.7,2.3,5.3,5.3,0,0,0,1.4,4.8,7.5,7.5,0,0,0,2.3,1.6A9.4,9.4,0,0,0,360.7,128.7Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-58"
              d="M355.4,119.9a15.4,15.4,0,0,1,2.7-4,16.1,16.1,0,0,1,6.4-4.6,10,10,0,0,1,3.3-.6,7.7,7.7,0,0,1,3.6.8,6.7,6.7,0,0,1,3.3,7.8,8.9,8.9,0,0,1-3.8,4.7,18.8,18.8,0,0,1-6.4,2.5,17.8,17.8,0,0,1-3.8.5,7.8,7.8,0,0,1-3.2-.6,5.9,5.9,0,0,1-1.8-1.2,3.7,3.7,0,0,1-1-3.4A9.3,9.3,0,0,1,355.4,119.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_24"
            data-name="24"
            class="tooth"
            :class="{ active: isSelected(24), highlight: isHighlight(24) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-59"
              d="M353.1,111.7a10.4,10.4,0,0,0,2.8-.4,20.8,20.8,0,0,0,5.1-2.4,14.2,14.2,0,0,0,4.3-3.6,7.9,7.9,0,0,0-.5-9.8,8.8,8.8,0,0,0-6.6-2.9l-2,.2a11.5,11.5,0,0,0-7.4,5.7,15.2,15.2,0,0,0-1.8,7.8,5.3,5.3,0,0,0,3.2,4.7h.3A7.7,7.7,0,0,0,353.1,111.7Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-60"
              d="M356.6,94.4l1.6-.2a7.2,7.2,0,0,1,5.4,2.3,6.3,6.3,0,0,1,.4,7.8,12.8,12.8,0,0,1-3.9,3.2,19.4,19.4,0,0,1-4.7,2.2,8.8,8.8,0,0,1-2.3.3,6.1,6.1,0,0,1-2-.3h-.2a3.6,3.6,0,0,1-2.2-3.3,13.6,13.6,0,0,1,1.6-7A9.9,9.9,0,0,1,356.6,94.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_23"
            data-name="23"
            class="tooth"
            :class="{ active: isSelected(23), highlight: isHighlight(23) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-61"
              d="M341.1,95.9a12.4,12.4,0,0,0,3-.4,30.7,30.7,0,0,0,6.6-2.5,9.4,9.4,0,0,0,4.7-5.7c1.8-6.1-3.8-11.4-9.5-12.1a6,6,0,0,0-3.9.6,6.7,6.7,0,0,0-2.3,3.4,42.9,42.9,0,0,0-2.8,10.4c-.2,1.6-.3,3.7.8,5a4.3,4.3,0,0,0,2.9,1.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-62"
              d="M341.1,79.7a5.6,5.6,0,0,1,1.7-2.6,3.5,3.5,0,0,1,1.8-.4h1.1a10.6,10.6,0,0,1,7.2,4.4,6.7,6.7,0,0,1,.9,5.6,7.8,7.8,0,0,1-3.9,4.7,29.1,29.1,0,0,1-6.2,2.4,10.9,10.9,0,0,1-2.6.4h-.5a2.8,2.8,0,0,1-1.8-.8c-.7-.8-.6-2.5-.4-3.7A41.3,41.3,0,0,1,341.1,79.7Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_22"
            data-name="22"
            class="tooth"
            :class="{ active: isSelected(22), highlight: isHighlight(22) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-63"
              d="M325.9,84.2a6.6,6.6,0,0,0,4.7-.5,19,19,0,0,0,4.8-3.3h.2c2.2-1.9,4.4-3.8,5.5-6.2a2.1,2.1,0,0,0,.2-1.2c-.3-1.7-2.7-3.3-4.1-4.3h-.2l-3.4-2a40,40,0,0,0-4-1.5,15.7,15.7,0,0,0-4.8-.8,1.5,1.5,0,0,0-1.1.4,2.1,2.1,0,0,0-.3.7,43.1,43.1,0,0,0-1.5,13.1,8.4,8.4,0,0,0,1.8,4.6,5.4,5.4,0,0,0,2,1.2Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-64"
              d="M325,65.8a14.5,14.5,0,0,1,4.2.7l3.7,1.4,3.1,1.9h.2c1,.7,3.2,2.2,3.4,3.3a.5.5,0,0,1-.1.3c-1,2.1-3.1,3.9-5.1,5.6h-.2a17.5,17.5,0,0,1-4.4,3.1,5.8,5.8,0,0,1-2.4.6l-1.2-.2h-.1a3.8,3.8,0,0,1-1.4-.9,7.1,7.1,0,0,1-1.3-3.6,41.9,41.9,0,0,1,1.4-12.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_21"
            data-name="21"
            class="tooth"
            :class="{ active: isSelected(21), highlight: isHighlight(21) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-65"
              d="M309.6,79.9a7.2,7.2,0,0,0,4.7-1.9,20.6,20.6,0,0,0,4-4.9v-.2c1.7-2.6,3.4-5.3,3.8-8.1a2.2,2.2,0,0,0-.2-1.4c-.9-1.7-3.8-2.6-5.6-3.2h-.2l-4.1-1.1a43.4,43.4,0,0,0-4.6-.3,17,17,0,0,0-5.3.7,1.6,1.6,0,0,0-1,.8,2.2,2.2,0,0,0-.1.8A46.7,46.7,0,0,0,303.7,75a9.1,9.1,0,0,0,3.2,4.2,5.8,5.8,0,0,0,2.5.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-66"
              d="M307.4,60.3h.2l4.3.3,3.9,1h.2c1.2.4,4.1,1.3,4.6,2.4a.7.7,0,0,1,0,.4c-.4,2.5-2,5-3.6,7.5v.2a19,19,0,0,1-3.6,4.6,5.6,5.6,0,0,1-3.6,1.5h-.1a4.3,4.3,0,0,1-1.8-.5,7.8,7.8,0,0,1-2.5-3.4,45.7,45.7,0,0,1-2.4-13.5A15.1,15.1,0,0,1,307.4,60.3Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
        </g>
        <g id="Milk_Lower" data-name="Milk Lower">
          <path
            id="Gum_milk_lower"
            data-name="Gum milk lower"
            class="cls-67"
            d="M243.6,251.6v.7c.3,1.6.6,3.2.9,4.7l.4,2.1c.3,1.8,1,4.1,3.1,5.4a7,7,0,0,0,3.6,1.1,8.4,8.4,0,0,0-2.1,3.5c-.8,3,0,6.1.8,8.8h0c1.9,7,4.8,10.9,8,10.9l1.3-.2a12,12,0,0,0-.1,6.7,13.2,13.2,0,0,0,8.1,9.2,4.4,4.4,0,0,0,1.5.3h.2a5.4,5.4,0,0,0,.1.8c.4,2.6,2.4,4.4,3.8,5.6h.1a23.5,23.5,0,0,0,2.7,2.1h.1a26.8,26.8,0,0,0,3.1,1.5,10.8,10.8,0,0,0,3.9.8h.6c1,1.9,3,2.8,4.9,3.6h.1l3.2,1.1h.1a25.9,25.9,0,0,0,3.5.3h.2a11.1,11.1,0,0,0,4.3-.7l.8-.5.8.5a11.1,11.1,0,0,0,4.3.7h.2a25.8,25.8,0,0,0,3.5-.3h.1l3.2-1.1h.1c1.9-.8,3.8-1.8,4.9-3.6h.6a10.8,10.8,0,0,0,3.9-.8,26.9,26.9,0,0,0,3.1-1.5h.1a23.5,23.5,0,0,0,2.7-2.1h.1c1.3-1.1,3.4-3,3.8-5.6a5.4,5.4,0,0,0,.1-.8h.2a4.4,4.4,0,0,0,1.5-.3,13.2,13.2,0,0,0,8.1-9.2,12,12,0,0,0-.1-6.7l1.3.2c3.3,0,6.1-3.9,8-10.9h0c.7-2.7,1.6-5.7.8-8.8a8.4,8.4,0,0,0-2.1-3.5,7,7,0,0,0,3.6-1.1c2.3-1.5,2.8-4.2,3.1-5.4l.4-2.1c.3-1.5.6-3.1.9-4.7v-.7c.3-1.8.7-4.2.1-6.3s-3-3.9-4.9-5.1l-1.1-.7a14.6,14.6,0,0,0-5-2.3l-1.4-.2h-2.3c-6.3.4-11.9,5.5-14.6,13-6.8,19.2-16.9,31.4-28.1,31.4s-21.3-12.2-28.1-31.4c-2.6-7.5-8.2-12.5-14.6-13H256l-1.4.2a14.6,14.6,0,0,0-5,2.3l-1.1.7c-1.9,1.2-4.1,2.6-4.9,5.1S243.3,249.8,243.6,251.6Z"
            transform="translate(-197.5 -51.3)"
          />
          <g
            id="_85"
            data-name="85"
            class="tooth"
            :class="{ active: isSelected(85), highlight: isHighlight(85) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-68"
              d="M258.1,240.4a10.9,10.9,0,0,1,4.5,6,19.1,19.1,0,0,1,.8,6.5,8.4,8.4,0,0,1-2.8,6.1h0a22.1,22.1,0,0,1-3.2,2l-.4.2a14.7,14.7,0,0,1-3.9,1.7h-.7a5.5,5.5,0,0,1-3.4-.8c-1.3-.8-1.7-2.2-2-3.7s-.9-4.4-1.3-6.7-.8-4-.3-5.5,2.3-2.8,3.9-3.8l1.2-.8a12.8,12.8,0,0,1,4.4-2A4.2,4.2,0,0,1,258.1,240.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-69"
              d="M256,241.3h-.9a11.7,11.7,0,0,0-4,1.8l-1.2.8c-1.3.9-3,1.9-3.4,3a10.2,10.2,0,0,0,.2,3.8v.8c.2,1.5.5,3,.8,4.5l.4,2.1c.3,1.3.5,2.2,1.4,2.7a4.4,4.4,0,0,0,2.4.6H253a14,14,0,0,0,3.6-1.6l.4-.2a21.2,21.2,0,0,0,3-1.9h0a6.8,6.8,0,0,0,2.2-4.9,17.1,17.1,0,0,0-.7-5.9,9.4,9.4,0,0,0-3.9-5.1h-.1A3.3,3.3,0,0,0,256,241.3Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_84"
            data-name="84"
            class="tooth"
            :class="{ active: isSelected(84), highlight: isHighlight(84) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-70"
              d="M262.3,262.8a9.1,9.1,0,0,1,4.6,4.8,19.6,19.6,0,0,1,1.5,6.3,9.8,9.8,0,0,1-2,6.9h0a23.5,23.5,0,0,1-2.9,2.7l-.4.3c-1.2,1-3.3,2.6-4.5,2.6-3.7,0-5.8-8.1-6.1-9.2s-1.3-4.9-.8-7,1.9-2.9,3.3-4l1-.9a12.6,12.6,0,0,1,3.7-2.4A3.5,3.5,0,0,1,262.3,262.8Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-71"
              d="M261,264l-1.1.3a11.4,11.4,0,0,0-3.3,2.2l-1,.9c-1.1,1-2.5,2.2-2.8,3.3s.1,3.8.7,6h0c1.1,3.9,3,8.2,5,8.2.5,0,1.9-.6,3.9-2.3l.4-.3a22.5,22.5,0,0,0,2.7-2.6h0a8,8,0,0,0,1.6-5.7,17.7,17.7,0,0,0-1.3-5.7,7.7,7.7,0,0,0-3.9-4.1h-.1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_83"
            data-name="83"
            class="tooth"
            :class="{ active: isSelected(83), highlight: isHighlight(83) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-72"
              d="M272,284.1a7,7,0,0,0-2.2.1,18.3,18.3,0,0,0-4.9,1.6c-2.8,1.4-4.3,5-3.3,8.8a10.9,10.9,0,0,0,6.8,7.6,1.8,1.8,0,0,0,1.6,0,4,4,0,0,0,1.7-2.3,47.5,47.5,0,0,0,2.9-9.4c.3-1.5.5-3.4-.1-4.7a3.2,3.2,0,0,0-2-1.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-73"
              d="M271.3,285.6h-1.3a17.4,17.4,0,0,0-4.7,1.5c-2.3,1.1-3.4,4-2.6,6.9a9.6,9.6,0,0,0,6,6.6l.6.2h.2c.5-.3.6-.5,1.1-1.7a45.8,45.8,0,0,0,2.8-9.1c.2-1.1.5-2.6,0-3.5a2,2,0,0,0-1.2-.9h-.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_82"
            data-name="82"
            class="tooth"
            :class="{ active: isSelected(82), highlight: isHighlight(82) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-74"
              d="M282.6,294.7a3.8,3.8,0,0,0-3.4.4,14.3,14.3,0,0,0-3.5,3.1h-.1a18.6,18.6,0,0,0-4,5.8,2.4,2.4,0,0,0-.1,1.2c.2,1.6,1.9,3.1,3,4h.1l2.4,1.9,2.9,1.4a9,9,0,0,0,3.5.7,1,1,0,0,0,.8-.4,2.3,2.3,0,0,0,.2-.6,51.5,51.5,0,0,0,1.1-12.3,9.2,9.2,0,0,0-1.3-4.3,3.9,3.9,0,0,0-1.5-1.1Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-75"
              d="M283.3,311.9a8.4,8.4,0,0,1-3-.7l-2.7-1.3-2.3-1.8h-.1c-.7-.6-2.3-2.1-2.5-3a.6.6,0,0,1,0-.2,17.6,17.6,0,0,1,3.7-5.3h.1a13.2,13.2,0,0,1,3.2-2.9,3.4,3.4,0,0,1,1.7-.5l.8.2h.1a2.7,2.7,0,0,1,1,.8,7.8,7.8,0,0,1,.9,3.3,50.1,50.1,0,0,1-1,11.6Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_81"
            data-name="81"
            class="tooth"
            :class="{ active: isSelected(81), highlight: isHighlight(81) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-76"
              d="M294.4,298.8a4.6,4.6,0,0,0-3.4,1.8,19.2,19.2,0,0,0-2.9,4.6v.2a24.1,24.1,0,0,0-2.8,7.6,2.6,2.6,0,0,0,.1,1.3c.6,1.5,2.8,2.4,4,3h.1l3,1,3.3.3a9.7,9.7,0,0,0,3.8-.6,1.2,1.2,0,0,0,.7-.7,2.7,2.7,0,0,0,.1-.7,55.1,55.1,0,0,0-1.8-13.2,8.4,8.4,0,0,0-2.3-3.9,3.5,3.5,0,0,0-1.8-.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-77"
              d="M296,317h-.2l-3.1-.3-2.8-1h-.1c-.9-.4-2.9-1.2-3.4-2.2a.8.8,0,0,1,0-.3,22.9,22.9,0,0,1,2.6-7V306a17.8,17.8,0,0,1,2.6-4.3,3.7,3.7,0,0,1,2.6-1.4h.1a2.6,2.6,0,0,1,1.3.4,7.4,7.4,0,0,1,1.8,3.2,53.9,53.9,0,0,1,1.7,12.6A8.7,8.7,0,0,1,296,317Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_75"
            data-name="75"
            class="tooth"
            :class="{ active: isSelected(75), highlight: isHighlight(75) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-78"
              d="M344,240.4a10.9,10.9,0,0,0-4.5,6,19.1,19.1,0,0,0-.8,6.5,8.4,8.4,0,0,0,2.8,6.1h0a22.1,22.1,0,0,0,3.2,2l.4.2a14.7,14.7,0,0,0,3.9,1.7h.7a5.5,5.5,0,0,0,3.4-.8c1.3-.8,1.7-2.2,2-3.7s.9-4.4,1.3-6.7.8-4,.3-5.5-2.3-2.8-3.9-3.8l-1.2-.8a12.8,12.8,0,0,0-4.4-2A4.2,4.2,0,0,0,344,240.4Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-79"
              d="M346.1,241.3h.9a11.7,11.7,0,0,1,4,1.8l1.2.8c1.3.9,3,1.9,3.4,3a10.2,10.2,0,0,1-.2,3.8v.8c-.2,1.5-.5,3-.8,4.5l-.4,2.1c-.3,1.3-.5,2.2-1.4,2.7a4.4,4.4,0,0,1-2.4.6h-1.1a14,14,0,0,1-3.6-1.6l-.4-.2a21.2,21.2,0,0,1-3-1.9h0a6.8,6.8,0,0,1-2.2-4.9,17.1,17.1,0,0,1,.7-5.9,9.4,9.4,0,0,1,3.9-5.1h.1A3.3,3.3,0,0,1,346.1,241.3Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_74"
            data-name="74"
            class="tooth"
            :class="{ active: isSelected(74), highlight: isHighlight(74) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-80"
              d="M339.8,262.8a9.1,9.1,0,0,0-4.6,4.8,19.6,19.6,0,0,0-1.5,6.3,9.8,9.8,0,0,0,2,6.9h0a23.5,23.5,0,0,0,2.9,2.7l.4.3c1.2,1,3.3,2.6,4.5,2.6,3.7,0,5.8-8.1,6.1-9.2s1.3-4.9.8-7-1.9-2.9-3.3-4l-1-.9a12.6,12.6,0,0,0-3.7-2.4A3.5,3.5,0,0,0,339.8,262.8Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-81"
              d="M341.1,264l1.1.3a11.4,11.4,0,0,1,3.3,2.2l1,.9c1.1,1,2.5,2.2,2.8,3.3s-.1,3.8-.7,6h0c-1.1,3.9-3,8.2-5,8.2-.5,0-1.9-.6-3.9-2.3l-.4-.3a22.5,22.5,0,0,1-2.7-2.6h0A8,8,0,0,1,335,274a17.7,17.7,0,0,1,1.3-5.7,7.7,7.7,0,0,1,3.9-4.1h.1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_73"
            data-name="73"
            class="tooth"
            :class="{ active: isSelected(73), highlight: isHighlight(73) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-82"
              d="M330.1,284.1a7,7,0,0,1,2.2.1,18.3,18.3,0,0,1,4.9,1.6c2.8,1.4,4.3,5,3.3,8.8a10.9,10.9,0,0,1-6.8,7.6,1.8,1.8,0,0,1-1.6,0,4,4,0,0,1-1.7-2.3,47.5,47.5,0,0,1-2.9-9.4c-.3-1.5-.5-3.4.1-4.7a3.2,3.2,0,0,1,2-1.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-83"
              d="M330.8,285.6h1.3a17.4,17.4,0,0,1,4.7,1.5c2.3,1.1,3.4,4,2.6,6.9a9.6,9.6,0,0,1-6,6.6l-.6.2h-.2c-.5-.3-.6-.5-1.1-1.7a45.8,45.8,0,0,1-2.8-9.1c-.2-1.1-.5-2.6,0-3.5a2,2,0,0,1,1.2-.9h.9Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_72"
            data-name="72"
            class="tooth"
            :class="{ active: isSelected(72), highlight: isHighlight(72) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-84"
              d="M319.5,294.7a3.8,3.8,0,0,1,3.4.4,14.3,14.3,0,0,1,3.5,3.1h.1a18.6,18.6,0,0,1,4,5.8,2.4,2.4,0,0,1,.1,1.2c-.2,1.6-1.9,3.1-3,4h-.1l-2.4,1.9-2.9,1.4a9,9,0,0,1-3.5.7,1,1,0,0,1-.8-.4,2.3,2.3,0,0,1-.2-.6,51.5,51.5,0,0,1-1.1-12.3,9.2,9.2,0,0,1,1.3-4.3,3.9,3.9,0,0,1,1.5-1.1Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-85"
              d="M318.8,311.9a8.4,8.4,0,0,0,3-.7l2.7-1.3,2.3-1.8h.1c.7-.6,2.3-2.1,2.5-3a.6.6,0,0,0,0-.2,17.6,17.6,0,0,0-3.7-5.3h-.1a13.2,13.2,0,0,0-3.2-2.9,3.4,3.4,0,0,0-1.7-.5l-.8.2h-.1a2.7,2.7,0,0,0-1,.8,7.8,7.8,0,0,0-.9,3.3,50.1,50.1,0,0,0,1,11.6Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_71"
            data-name="71"
            class="tooth"
            :class="{ active: isSelected(71), highlight: isHighlight(71) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-86"
              d="M307.7,298.8a4.6,4.6,0,0,1,3.4,1.8,19.2,19.2,0,0,1,2.9,4.6v.2a24.1,24.1,0,0,1,2.8,7.6,2.6,2.6,0,0,1-.1,1.3c-.6,1.5-2.8,2.4-4,3h-.1l-3,1-3.3.3a9.7,9.7,0,0,1-3.8-.6,1.2,1.2,0,0,1-.7-.7,2.7,2.7,0,0,1-.1-.7,55.1,55.1,0,0,1,1.8-13.2,8.4,8.4,0,0,1,2.3-3.9,3.5,3.5,0,0,1,1.8-.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-87"
              d="M306.1,317h.2l3.1-.3,2.8-1h.1c.9-.4,2.9-1.2,3.4-2.2a.8.8,0,0,0,0-.3,22.9,22.9,0,0,0-2.6-7V306a17.8,17.8,0,0,0-2.6-4.3,3.7,3.7,0,0,0-2.6-1.4h-.1a2.6,2.6,0,0,0-1.3.4,7.4,7.4,0,0,0-1.8,3.2,53.9,53.9,0,0,0-1.7,12.6A8.7,8.7,0,0,0,306.1,317Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
        </g>
        <g id="Milk_upper" data-name="Milk upper">
          <path
            id="Gum_milk_upper"
            data-name="Gum milk upper"
            class="cls-67"
            d="M363.2,191.9v-.7c-.3-1.6-.6-3.2-1-4.7l-.5-2.1a7.6,7.6,0,0,0-3.4-5.4,8.2,8.2,0,0,0-4-1.1,8.3,8.3,0,0,0,2.3-3.5c.9-3,0-6.1-.8-8.8h0c-2.1-7-5.2-10.9-8.8-10.9l-1.4.2a11,11,0,0,0,.1-6.7,13.7,13.7,0,0,0-8.9-9.2,5.2,5.2,0,0,0-1.7-.3h-.2a5,5,0,0,0-.1-.8c-.4-2.6-2.7-4.4-4.2-5.6h-.1a25.6,25.6,0,0,0-2.9-2.1h-.1a30.8,30.8,0,0,0-3.4-1.5,12.9,12.9,0,0,0-4.3-.8h-.7c-1.1-1.9-3.3-2.8-5.4-3.6h-.2l-3.5-1.1h-.2a31.1,31.1,0,0,0-3.9-.3h-.2a13.3,13.3,0,0,0-4.7.7l-.9.5-.9-.5a13.3,13.3,0,0,0-4.7-.7h-.2a31.1,31.1,0,0,0-3.9.3h-.2l-3.5,1.1h-.2c-2.1.8-4.2,1.8-5.4,3.6h-.7a12.9,12.9,0,0,0-4.3.8A30.8,30.8,0,0,0,273,130h-.1a25.7,25.7,0,0,0-2.9,2.1h-.1c-1.4,1.1-3.7,3-4.2,5.6a5,5,0,0,0-.1.8h-.2a5.2,5.2,0,0,0-1.7.3,13.7,13.7,0,0,0-8.9,9.2,11,11,0,0,0,.1,6.7l-1.4-.2c-3.6,0-6.7,3.9-8.8,10.9h0c-.8,2.7-1.7,5.7-.8,8.8a8.3,8.3,0,0,0,2.3,3.5,8.2,8.2,0,0,0-4,1.1c-2.5,1.5-3.1,4.2-3.4,5.4l-.5,2.1c-.3,1.5-.7,3.1-1,4.7v.7c-.3,1.8-.8,4.2-.1,6.3s3.3,3.9,5.4,5.1l1.2.7a16.7,16.7,0,0,0,5.5,2.3l1.6.2h.5a136.8,136.8,0,0,1,24-4.6c8-.8,13.9-.7,25.5-.4,8,.2,15.5.4,25.5,1.4s17.1,2.4,22.9,3.6h.5l1.6-.2a16.7,16.7,0,0,0,5.5-2.3l1.2-.7c2.1-1.2,4.4-2.6,5.4-5.1S363.5,193.7,363.2,191.9Z"
            transform="translate(-197.5 -51.3)"
          />
          <g
            id="_65"
            data-name="65"
            class="tooth"
            :class="{ active: isSelected(65), highlight: isHighlight(65) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-88"
              d="M347.4,203a11.1,11.1,0,0,1-5-6,17.5,17.5,0,0,1-.9-6.5,8.1,8.1,0,0,1,3-6.1h0a24.6,24.6,0,0,1,3.5-2l.4-.2a17,17,0,0,1,4.3-1.8h.8a6.5,6.5,0,0,1,3.8.8c1.4.8,1.9,2.1,2.2,3.7s1,4.4,1.4,6.7.9,4,.3,5.5-2.5,2.8-4.3,3.8l-1.3.8a14.7,14.7,0,0,1-4.8,2A5,5,0,0,1,347.4,203Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-89"
              d="M349.6,202.1h1a13.4,13.4,0,0,0,4.4-1.8l1.4-.8c1.5-.9,3.3-1.9,3.7-3s0-2.6-.3-3.8v-.8c-.3-1.5-.6-3-.9-4.5l-.5-2.1c-.3-1.3-.6-2.2-1.5-2.7a5.1,5.1,0,0,0-2.6-.6h-1.2a16.2,16.2,0,0,0-4,1.6l-.4.2a23.7,23.7,0,0,0-3.3,1.9h0a6.5,6.5,0,0,0-2.4,4.9,15.7,15.7,0,0,0,.8,5.9,9.5,9.5,0,0,0,4.3,5.1h.1A3.9,3.9,0,0,0,349.6,202.1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_64"
            data-name="64"
            class="tooth"
            :class="{ active: isSelected(64), highlight: isHighlight(64) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-90"
              d="M342.8,180.7a9.5,9.5,0,0,1-5-4.8,18.2,18.2,0,0,1-1.6-6.3,9.2,9.2,0,0,1,2.1-6.9h0a24.9,24.9,0,0,1,3.2-2.7l.4-.3c1.3-1,3.6-2.6,5-2.6,4,0,6.4,8.1,6.7,9.2s1.5,4.9.8,7-2.1,2.9-3.6,4l-1.1.9a14,14,0,0,1-4,2.4A4.2,4.2,0,0,1,342.8,180.7Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-91"
              d="M344.2,179.4l1.2-.3A12.7,12.7,0,0,0,349,177l1.1-.9c1.2-1,2.8-2.2,3.1-3.3s-.1-3.8-.8-6h0c-1.2-3.9-3.3-8.2-5.5-8.2-.6,0-2,.6-4.3,2.3l-.4.3a23.9,23.9,0,0,0-3,2.6h0a7.5,7.5,0,0,0-1.7,5.7,16.4,16.4,0,0,0,1.5,5.7,8.1,8.1,0,0,0,4.2,4.1h.1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_63"
            data-name="63"
            class="tooth"
            :class="{ active: isSelected(63), highlight: isHighlight(63) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-92"
              d="M332.1,159.3a8.4,8.4,0,0,0,2.4-.1,21.5,21.5,0,0,0,5.4-1.6c3.1-1.4,4.7-5,3.6-8.8a11.3,11.3,0,0,0-7.4-7.6,2.1,2.1,0,0,0-1.8,0,4.1,4.1,0,0,0-1.8,2.3,44.5,44.5,0,0,0-3.2,9.4c-.3,1.5-.6,3.4.1,4.7a3.4,3.4,0,0,0,2.2,1.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-93"
              d="M332.9,157.9h1.4a20.4,20.4,0,0,0,5.1-1.5,5.5,5.5,0,0,0,2.8-6.9,10,10,0,0,0-6.6-6.6l-.7-.2h-.2c-.6.3-.7.5-1.2,1.7a42.8,42.8,0,0,0-3,9.1c-.2,1.1-.5,2.6,0,3.5a2.2,2.2,0,0,0,1.4.9h1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_62"
            data-name="62"
            class="tooth"
            :class="{ active: isSelected(62), highlight: isHighlight(62) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-94"
              d="M320.4,148.7a4.6,4.6,0,0,0,3.7-.4,15.3,15.3,0,0,0,3.8-3.1h.1c1.7-1.8,3.5-3.6,4.4-5.8a2.2,2.2,0,0,0,.1-1.2c-.3-1.6-2.1-3.1-3.2-4h-.1l-2.7-1.9-3.1-1.4a10.7,10.7,0,0,0-3.8-.7,1.1,1.1,0,0,0-.9.4,2.1,2.1,0,0,0-.2.6,47.1,47.1,0,0,0-1.2,12.3,8.6,8.6,0,0,0,1.4,4.3,4.2,4.2,0,0,0,1.6,1.1Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-95"
              d="M319.7,131.5a9.9,9.9,0,0,1,3.3.7l3,1.3,2.5,1.8h.1c.8.6,2.6,2.1,2.7,3a.6.6,0,0,1-.1.2c-.8,1.9-2.4,3.6-4,5.3h-.1a14.1,14.1,0,0,1-3.5,2.9,4,4,0,0,1-1.9.5l-.9-.2h-.1a3,3,0,0,1-1.1-.8,7.3,7.3,0,0,1-1-3.3,45.8,45.8,0,0,1,1.1-11.6Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_61"
            data-name="61"
            class="tooth"
            :class="{ active: isSelected(61), highlight: isHighlight(61) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-96"
              d="M307.5,144.7a5.3,5.3,0,0,0,3.8-1.8,19.1,19.1,0,0,0,3.1-4.6v-.2c1.3-2.4,2.7-5,3-7.6a2.4,2.4,0,0,0-.1-1.3c-.7-1.5-3-2.4-4.4-3h-.2l-3.3-1-3.6-.3a11.6,11.6,0,0,0-4.2.6,1.3,1.3,0,0,0-.8.7,2.4,2.4,0,0,0-.1.7,50.6,50.6,0,0,0,2,13.2,8.4,8.4,0,0,0,2.6,3.9,4.1,4.1,0,0,0,2,.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-97"
              d="M305.7,126.4h.2l3.4.3,3.1,1h.2c1,.4,3.2,1.2,3.7,2.2a.7.7,0,0,1,0,.3c-.3,2.3-1.6,4.7-2.9,7v.2a17.6,17.6,0,0,1-2.9,4.3,4.2,4.2,0,0,1-2.9,1.4h-.1a3,3,0,0,1-1.4-.4,7.3,7.3,0,0,1-2-3.2,49.5,49.5,0,0,1-1.9-12.6A10.3,10.3,0,0,1,305.7,126.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_55"
            data-name="55"
            class="tooth"
            :class="{ active: isSelected(55), highlight: isHighlight(55) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-98"
              d="M253,203a11.1,11.1,0,0,0,5-6,17.5,17.5,0,0,0,.9-6.5,8.1,8.1,0,0,0-3-6.1h0a24.6,24.6,0,0,0-3.5-2l-.4-.2a17,17,0,0,0-4.3-1.8h-.8a6.5,6.5,0,0,0-3.8.8c-1.4.8-1.9,2.1-2.2,3.7s-1,4.4-1.4,6.7-.9,4-.3,5.5,2.5,2.8,4.3,3.8l1.3.8a14.7,14.7,0,0,0,4.8,2A5,5,0,0,0,253,203Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-99"
              d="M250.8,202.1h-1a13.4,13.4,0,0,1-4.4-1.8l-1.4-.8c-1.5-.9-3.3-1.9-3.7-3s0-2.6.3-3.8v-.8c.3-1.5.6-3,.9-4.5l.5-2.1c.3-1.3.6-2.2,1.5-2.7a5.1,5.1,0,0,1,2.6-.6h1.2a16.2,16.2,0,0,1,4,1.6l.4.2a23.7,23.7,0,0,1,3.3,1.9h0a6.5,6.5,0,0,1,2.4,4.9,15.7,15.7,0,0,1-.8,5.9,9.5,9.5,0,0,1-4.3,5.1h-.1A3.9,3.9,0,0,1,250.8,202.1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_54"
            data-name="54"
            class="tooth"
            :class="{ active: isSelected(54), highlight: isHighlight(54) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-100"
              d="M257.6,180.7a9.5,9.5,0,0,0,5-4.8,18.2,18.2,0,0,0,1.6-6.3,9.2,9.2,0,0,0-2.1-6.9h0a24.9,24.9,0,0,0-3.2-2.7l-.4-.3c-1.3-1-3.6-2.6-5-2.6-4,0-6.4,8.1-6.7,9.2s-1.5,4.9-.8,7,2.1,2.9,3.6,4l1.1.9a14,14,0,0,0,4,2.4A4.2,4.2,0,0,0,257.6,180.7Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-101"
              d="M256.2,179.4l-1.2-.3a12.7,12.7,0,0,1-3.6-2.2l-1.1-.9c-1.2-1-2.8-2.2-3.1-3.3s.1-3.8.8-6h0c1.2-3.9,3.3-8.2,5.5-8.2.6,0,2,.6,4.3,2.3l.4.3a23.9,23.9,0,0,1,3,2.6h0a7.5,7.5,0,0,1,1.7,5.7,16.4,16.4,0,0,1-1.5,5.7,8.1,8.1,0,0,1-4.2,4.1h-.1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_53"
            data-name="53"
            class="tooth"
            :class="{ active: isSelected(53), highlight: isHighlight(53) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-102"
              d="M268.3,159.3a8.4,8.4,0,0,1-2.4-.1,21.5,21.5,0,0,1-5.4-1.6c-3.1-1.4-4.7-5-3.6-8.8a11.3,11.3,0,0,1,7.4-7.6,2.1,2.1,0,0,1,1.8,0,4.1,4.1,0,0,1,1.8,2.3,44.5,44.5,0,0,1,3.2,9.4c.3,1.5.6,3.4-.1,4.7a3.4,3.4,0,0,1-2.2,1.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-103"
              d="M267.5,157.9h-1.4a20.4,20.4,0,0,1-5.1-1.5,5.5,5.5,0,0,1-2.8-6.9,10,10,0,0,1,6.6-6.6l.7-.2h.2c.6.3.7.5,1.2,1.7a42.8,42.8,0,0,1,3,9.1c.2,1.1.5,2.6,0,3.5a2.2,2.2,0,0,1-1.4.9h-1Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_52"
            data-name="52"
            class="tooth"
            :class="{ active: isSelected(52), highlight: isHighlight(52) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-104"
              d="M280,148.7a4.6,4.6,0,0,1-3.7-.4,15.3,15.3,0,0,1-3.8-3.1h-.1c-1.7-1.8-3.5-3.6-4.4-5.8a2.2,2.2,0,0,1-.1-1.2c.3-1.6,2.1-3.1,3.2-4h.1l2.7-1.9,3.1-1.4a10.8,10.8,0,0,1,3.8-.7,1.1,1.1,0,0,1,.9.4,2.1,2.1,0,0,1,.2.6,47.1,47.1,0,0,1,1.2,12.3,8.6,8.6,0,0,1-1.4,4.3,4.2,4.2,0,0,1-1.6,1.1Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-105"
              d="M280.7,131.5a9.9,9.9,0,0,0-3.3.7l-3,1.3-2.5,1.8h-.1c-.8.6-2.6,2.1-2.7,3a.6.6,0,0,0,.1.2c.8,1.9,2.4,3.6,4,5.3h.1a14.1,14.1,0,0,0,3.5,2.9,4,4,0,0,0,1.9.5l.9-.2h.1a3,3,0,0,0,1.1-.8,7.3,7.3,0,0,0,1-3.3,45.8,45.8,0,0,0-1.1-11.6Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
          <g
            id="_51"
            data-name="51"
            class="tooth"
            :class="{ active: isSelected(51), highlight: isHighlight(51) }"
            @click="handleClick"
            @mouseover="handleMouseOver"
            @mouseleave="handleMouseLeave"
          >
            <path
              class="cls-106"
              d="M292.9,144.7a5.3,5.3,0,0,1-3.8-1.8,19.1,19.1,0,0,1-3.1-4.6v-.2c-1.3-2.4-2.7-5-3-7.6a2.4,2.4,0,0,1,.1-1.3c.7-1.5,3-2.4,4.4-3h.2l3.3-1,3.6-.3a11.6,11.6,0,0,1,4.2.6,1.3,1.3,0,0,1,.8.7,2.4,2.4,0,0,1,.1.7,50.6,50.6,0,0,1-2,13.2,8.4,8.4,0,0,1-2.6,3.9,4.1,4.1,0,0,1-2,.6Z"
              transform="translate(-197.5 -51.3)"
            />
            <path
              class="cls-107"
              d="M294.6,126.4h-.2l-3.4.3-3.1,1h-.2c-1,.4-3.2,1.2-3.7,2.2a.7.7,0,0,0,0,.3c.3,2.3,1.6,4.7,2.9,7v.2a17.6,17.6,0,0,0,2.9,4.3,4.2,4.2,0,0,0,2.9,1.4h.1a3,3,0,0,0,1.4-.4,7.3,7.3,0,0,0,2-3.2,49.5,49.5,0,0,0,1.9-12.6A10.3,10.3,0,0,0,294.6,126.4Z"
              transform="translate(-197.5 -51.3)"
            />
          </g>
        </g>
        <g id="Text">
          <text
            data-name="91"
            data-bg="#Q1BG"
            class="cls-108"
            transform="translate(9.3 50.9)"
            @mouseover="
              highlightBG('#Q1BG');
              handleMouseOver($event);
            "
            @mouseleave="
              handleMouseLeave();
              defaultBG('#Q1BG', 91);
            "
            @click="handleClick"
          >
            Q1
          </text>
          <text
            data-name="92"
            data-bg="#Q2BG"
            class="cls-108"
            transform="translate(176.9 50.9)"
            @mouseover="
              highlightBG('#Q2BG');
              handleMouseOver($event);
            "
            @mouseleave="
              handleMouseLeave();
              defaultBG('#Q2BG', 92);
            "
            @click="handleClick"
          >
            Q2
          </text>
          <text
            data-name="93"
            data-bg="#Q3BG"
            class="cls-108"
            transform="translate(165.4 302.2)"
            @mouseover="
              highlightBG('#Q3BG');
              handleMouseOver($event);
            "
            @mouseleave="
              handleMouseLeave();
              defaultBG('#Q3BG', 93);
            "
            @click="handleClick"
          >
            Q3
          </text>
          <text
            data-name="94"
            data-bg="#Q4BG"
            class="cls-108"
            transform="translate(18.2 301.4)"
            @mouseover="
              highlightBG('#Q4BG');
              handleMouseOver($event);
            "
            @mouseleave="
              handleMouseLeave();
              defaultBG('#Q4BG', 94);
            "
            @click="handleClick"
          >
            Q4
          </text>
          <text
            data-name="95"
            data-bg=".upper"
            class="cls-108"
            transform="translate(82.4 131.7)"
            @mouseover="
              highlightBG('.upper');
              handleMouseOver($event);
            "
            @mouseleave="
              handleMouseLeave();
              defaultBG('.upper', 95);
            "
            @click="handleClick"
          >
            Upper
          </text>
          <text
            data-name="96"
            data-bg=".lower"
            class="cls-108"
            transform="translate(83 212)"
            @mouseover="
              highlightBG('.lower');
              handleMouseOver($event);
            "
            @mouseleave="
              handleMouseLeave();
              defaultBG('.lower', 96);
            "
            @click="handleClick"
          >
            Lower
          </text>
          <text
            data-name="97"
            data-bg=".fm"
            class="cls-108"
            transform="translate(67.8 174.2)"
            @mouseover="
              highlightBG('.fm');
              handleMouseOver($event);
            "
            @mouseleave="
              handleMouseLeave();
              defaultBG('.fm', 97);
            "
            @click="handleClick"
          >
            Full mouth
          </text>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";

export default {
  props: { value: Array, disabled: Boolean, highlightItems: Array },

  data() {
    return {
      selectedItems: [],
      hoverItem: null,
    };
  },
  computed: {
    ...mapGetters({
      getToothBy: "moduleMaster/getToothBy",
    }),
  },
  watch: {
    value(val) {
      this.selectedItems = val?.map(i => i.id) || [];
    },
    // toothId() {
    //   if (this.toothId == null) {
    //     this.defaultBG(".fm", 97);
    //   }
    // },
  },
  mounted() {
    if (this.value) {
      this.selectedItems = this.value.map(i => i.id) || [];
    }
  },
  methods: {
    handleMouseOver(e) {
      this.hoverItem = parseInt(this.getDataName(e));
      this.$emit("hoveringTooth", this.hoverItem);
    },
    handleMouseLeave(e) {
      this.hoverItem = null;
    },
    isHovered(e) {
      return e.includes(this.hoverItem);
    },
    handleClick(e) {
      if (this.disabled) return;

      let item = parseInt(this.getDataName(e));

      if (this.selectedItems.includes(item)) {
        this.selectedItems = this.selectedItems.filter(e => e !== item);
      } else if (item > 90) {
        this.selectedItems = [];
        // this.selectedItems = this.selectedItems.filter((e) => e < 90);
        this.selectedItems.push(item);

        // this.selectedItems.push(item);
        // this.selectedItems = this.selectedItems
        //   .filter((i) => i < 90)
        //   .push(item);
      } else {
        this.selectedItems = this.selectedItems.filter(e => e < 90);
        this.selectedItems.push(item);
      }
      this.formatItems(this.selectedItems);

      this.$emit("input", this.formatItems(this.selectedItems));

      // this.hlSelectedItem();
      // let toothId = this.getDataName(e);
      // this.$emit("update:toothId", toothId);
      // this.$nextTick(() => {
      //   this.$emit("close");
      // });
    },
    isSelected(val) {
      return this.selectedItems?.includes(val);
    },
    isHighlight(val) {
      return this.highlightItems?.includes(val);
    },
    isContainSelected(arr) {
      return this.selectedItems?.some(i => arr.includes(i));
    },
    isContainHightlight(arr) {
      return this.highlightItems?.some(i => arr.includes(i));
    },

    highlightBG(el, id, color = "#a6dcef") {},
    defaultBG(el, id) {},
    getDataName(e) {
      let name;
      if (e.target.nodeName === "path" || e.target.nodeName === "tspan") {
        name = e.target.parentNode.dataset.name;
      } else {
        name = e.target.dataset.name;
      }
      return name;
    },
    formatItems(arr) {
      return arr.map(i => this.getToothBy(i, "id"));
    },
  },
};
</script>

<style scoped>
.tooth:hover * {
  fill: #a6dcef;
}
.tooth.active * {
  fill: #2a9df4;
}
.tooth.highlight * {
  fill: #a676ff;
}

path.is-hover {
  fill: #a6dcef;
}
path.active {
  fill: #2a9df4;
}
path.highlight {
  fill: #a676ff;
}

text {
  cursor: default;
}
.cls-1 {
  fill: #f7e2e8;
}

.cls-2 {
  fill: #ff8392;
}

.cls-3 {
  fill: url(#gradient_137);
}

.cls-4 {
  fill: url(#gradient_132);
}

.cls-5 {
  fill: url(#gradient_137-2);
}

.cls-6 {
  fill: url(#gradient_3);
}

.cls-7 {
  fill: url(#gradient_137-3);
}

.cls-8 {
  fill: url(#gradient_3-2);
}

.cls-9 {
  fill: url(#gradient_137-4);
}

.cls-10 {
  fill: url(#gradient_3-3);
}

.cls-11 {
  fill: url(#gradient_137-5);
}

.cls-12 {
  fill: url(#gradient_3-4);
}

.cls-13 {
  fill: url(#gradient_137-6);
}

.cls-14 {
  fill: url(#gradient_3-5);
}

.cls-15 {
  fill: url(#gradient_137-7);
}

.cls-16 {
  fill: url(#gradient_3-6);
}

.cls-17 {
  fill: url(#gradient_138);
}

.cls-18 {
  fill: url(#gradient_136);
}

.cls-19 {
  fill: url(#gradient_137-8);
}

.cls-20 {
  fill: url(#gradient_132-2);
}

.cls-21 {
  fill: url(#gradient_137-9);
}

.cls-22 {
  fill: url(#gradient_3-7);
}

.cls-23 {
  fill: url(#gradient_137-10);
}

.cls-24 {
  fill: url(#gradient_3-8);
}

.cls-25 {
  fill: url(#gradient_137-11);
}

.cls-26 {
  fill: url(#gradient_3-9);
}

.cls-27 {
  fill: url(#gradient_137-12);
}

.cls-28 {
  fill: url(#gradient_3-10);
}

.cls-29 {
  fill: url(#gradient_137-13);
}

.cls-30 {
  fill: url(#gradient_3-11);
}

.cls-31 {
  fill: url(#gradient_137-14);
}

.cls-32 {
  fill: url(#gradient_3-12);
}

.cls-33 {
  fill: url(#gradient_138-2);
}

.cls-34 {
  fill: url(#gradient_136-2);
}

.cls-35 {
  fill: url(#gradient_137-15);
}

.cls-36 {
  fill: url(#gradient_132-3);
}

.cls-37 {
  fill: url(#gradient_137-16);
}

.cls-38 {
  fill: url(#gradient_3-13);
}

.cls-39 {
  fill: url(#gradient_137-17);
}

.cls-40 {
  fill: url(#gradient_3-14);
}

.cls-41 {
  fill: url(#gradient_137-18);
}

.cls-42 {
  fill: url(#gradient_3-15);
}

.cls-43 {
  fill: url(#gradient_137-19);
}

.cls-44 {
  fill: url(#gradient_3-16);
}

.cls-45 {
  fill: url(#gradient_137-20);
}

.cls-46 {
  fill: url(#gradient_3-17);
}

.cls-47 {
  fill: url(#gradient_137-21);
}

.cls-48 {
  fill: url(#gradient_3-18);
}

.cls-49 {
  fill: url(#gradient_138-3);
}

.cls-50 {
  fill: url(#gradient_136-3);
}

.cls-51 {
  fill: url(#gradient_137-22);
}

.cls-52 {
  fill: url(#gradient_132-4);
}

.cls-53 {
  fill: url(#gradient_137-23);
}

.cls-54 {
  fill: url(#gradient_3-19);
}

.cls-55 {
  fill: url(#gradient_137-24);
}

.cls-56 {
  fill: url(#gradient_3-20);
}

.cls-57 {
  fill: url(#gradient_137-25);
}

.cls-58 {
  fill: url(#gradient_3-21);
}

.cls-59 {
  fill: url(#gradient_137-26);
}

.cls-60 {
  fill: url(#gradient_3-22);
}

.cls-61 {
  fill: url(#gradient_137-27);
}

.cls-62 {
  fill: url(#gradient_3-23);
}

.cls-63 {
  fill: url(#gradient_137-28);
}

.cls-64 {
  fill: url(#gradient_3-24);
}

.cls-65 {
  fill: url(#gradient_138-4);
}

.cls-66 {
  fill: url(#gradient_136-4);
}

.cls-67 {
  fill: #ffbbc6;
}

.cls-68 {
  fill: url(#gradient_137-29);
}

.cls-69 {
  fill: url(#gradient_3-25);
}

.cls-70 {
  fill: url(#gradient_137-30);
}

.cls-71 {
  fill: url(#gradient_3-26);
}

.cls-72 {
  fill: url(#gradient_137-31);
}

.cls-73 {
  fill: url(#gradient_3-27);
}

.cls-74 {
  fill: url(#gradient_137-32);
}

.cls-75 {
  fill: url(#gradient_3-28);
}

.cls-76 {
  fill: url(#gradient_138-5);
}

.cls-77 {
  fill: url(#gradient_136-5);
}

.cls-78 {
  fill: url(#gradient_137-33);
}

.cls-79 {
  fill: url(#gradient_3-29);
}

.cls-80 {
  fill: url(#gradient_137-34);
}

.cls-81 {
  fill: url(#gradient_3-30);
}

.cls-82 {
  fill: url(#gradient_137-35);
}

.cls-83 {
  fill: url(#gradient_3-31);
}

.cls-84 {
  fill: url(#gradient_137-36);
}

.cls-85 {
  fill: url(#gradient_3-32);
}

.cls-86 {
  fill: url(#gradient_138-6);
}

.cls-87 {
  fill: url(#gradient_136-6);
}

.cls-88 {
  fill: url(#gradient_137-37);
}

.cls-89 {
  fill: url(#gradient_3-33);
}

.cls-90 {
  fill: url(#gradient_137-38);
}

.cls-91 {
  fill: url(#gradient_3-34);
}

.cls-92 {
  fill: url(#gradient_137-39);
}

.cls-93 {
  fill: url(#gradient_3-35);
}

.cls-94 {
  fill: url(#gradient_137-40);
}

.cls-95 {
  fill: url(#gradient_3-36);
}

.cls-96 {
  fill: url(#gradient_138-7);
}

.cls-97 {
  fill: url(#gradient_136-7);
}

.cls-98 {
  fill: url(#gradient_137-41);
}

.cls-99 {
  fill: url(#gradient_3-37);
}

.cls-100 {
  fill: url(#gradient_137-42);
}

.cls-101 {
  fill: url(#gradient_3-38);
}

.cls-102 {
  fill: url(#gradient_137-43);
}

.cls-103 {
  fill: url(#gradient_3-39);
}

.cls-104 {
  fill: url(#gradient_137-44);
}

.cls-105 {
  fill: url(#gradient_3-40);
}

.cls-106 {
  fill: url(#gradient_138-8);
}

.cls-107 {
  fill: url(#gradient_136-8);
}

.cls-108 {
  font-size: 15px;
  fill: #774d54;
  /* font-family: Avenir-Roman, Avenir; */
}

.cls-109 {
  letter-spacing: 0em;
}

.cls-110 {
  letter-spacing: 0em;
}
</style>